import {
  faBuilding,
  faCalendar,
  faCar,
  faCartPlus,
  faCheckCircle,
  faClock,
  faCoins,
  faCreditCard,
  faDownload,
  faEnvelope,
  faEye,
  faGlobe,
  faIdCard,
  faKey,
  faLock,
  faPercent,
  faPhone,
  faPlus,
  faPlusCircle,
  faSave,
  faSuitcase,
  faTrash,
  faUser,
  faExclamationCircle,
} from "@fortawesome/fontawesome-free-solid";
import {
  faAdd,
  faArrowTurnRight,
  faArrowTurnUp,
  faBank,
  faCalendarDay,
  faCarAlt,
  faCity,
  faContactBook,
  faDollar,
  faEarthAmericas,
  faLineChart,
  faLocationDot,
  faMapLocationDot,
  faNoteSticky,
  faPlaneUp,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  ArrowDownIcon,
  ChevronDownIcon,
  ChevronRightIcon,
  PlayIcon,
  PlusIcon,
} from "@heroicons/react/solid";
import { Radio } from "@material-ui/core";
import { ArrowRight } from "@material-ui/icons";
import {
  Button,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  RadioGroup,
  Tooltip,
} from "@mui/material";
import { Spinner } from "@material-tailwind/react";
import React, { useEffect } from "react";
import CsvDownloader from "react-csv-downloader";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setEvent, setRegion } from "../../redux/app/event/event-slice";
import InputField from "./InputField";
import CountryList from "country-list-with-dial-code-and-flag";
import Select from "react-select";
import {
  setCity,
  setCountryCode,
  setCountryInput,
  setStatus,
} from "../../redux/app/affiliate/affiliate-slice";
import moment from "moment";
import DatePicker from "react-date-picker";
import TimePicker from "../../utils/TimePicker/TimePicker";
import _ from "lodash";
import {
  setBookingCreditCards,
  setTransactionRecordStoreStatus,
} from "../../redux/app/creditcard/creditcard-slice";
import { Link } from "react-router-dom";
import axios from "axios";
import {
  setEditBookingAllowed,
  setEditBookingError,
  setEditBookingTime,
  setQuoteBy,
} from "../../redux/app/booking/booking-slice";
import momenttz from "moment-timezone";
import { toast } from "react-toastify";
// ["DISABLE", "READ_ONLY", "ENABLE"],

let creditCardInitial = {};

const Modal = ({
  cancelOnClick,
  addOnClick,
  addButtonLabel,
  heading,
  isAddUser,
  isAddCompany,
  userNameInput,
  firstNameInput,
  lastNameInput,
  emailInput,
  passwordInput,
  confirmPasswordInput,
  mobileNumberInput,
  isDeleteRegion,
  companyNameInput,
  companyAddressInput,
  companyEmailInput,
  companyGstInput,
  companyWebsiteInput,
  isPermission,
  isEvent,
  isAffiliate,
  affiliateCity,
  setAffiliateCity,
  isVehicleEdit,
  vehicleCategory,
  vehicleStatusChange,
  vehicleTypeInput,
  noOfPassenger,
  noOfLuggage,
  vehicleDescription,
  vehicleDescriptionValue,
  noOfLuggageValue,
  noOfPassengerValue,
  vehicleTypeValue,
  vehicleImage,
  vehicleStatusValue,
  isVehicleAdd,
  categoryType,
  regionInput,
  vehicleImageInput,
  filterRegions,
  eventNameInput,
  startDateInput,
  endDateInput,
  markupInput,
  affiliateNameInput,
  contactNameInput,
  vehicleCategoryImage,
  usermarkupInput,
  usermarkupInputValue,
  userDiscountInput,
  userDiscountValue,
  addressInput,
  email1Input,
  email2Input,
  mobile1NumberInput,
  mobile2NumberInput,
  mobile3NumberInput,
  afiliateRegionsAdd,
  flightNumberInput,
  flightNumberUpdate,
  companyaffiliateIdNameInput,
  companyaffiliatePasswordInput,
  isSinglebooingDetailCanecl,
  cancelFeeCheckbox,
  cancelFeeInput,
  isSinglebooingDetailEdit,
  extraHourInput,
  extraHourUpdate,
  currencyInput,
  currencyUpdate,
  extraPriceInput,
  extraPriceUpdate,
  durationForAffiliateInput,
  durationForAffiliateUpdate,
  bookingType,
  countryCodeOnClick,
  codeUpdate,
  codeUpdateInput,
  priceUpdateInput,
  priceUpdate,
  isPriceEditBookingSummary,
  travelDate,
  travelTime,
  referenceNumberInput,
  referenceNumberUpdate,
  canelFeeInputValue,
  isSinglebooingDetailPaid,
  paymentNoteRef,
  paymentMethodInput,
  isSinglebooingDetailDocuments,
  documentInvoiceChange,
  documentVoucherChange,
  documentDriverChange,
  singleBookingEmailInputValue,
  singlebookEmailChangeInput,
  documentDownloadOnClick,
  paxUpdateInputfirst,
  paxtobeUpdateValuefirst,
  paxUpdateInputlast,
  paxtobeUpdateValuelast,
  contactNumberInput,
  contactNumberUpdate,
  travelDateInput,
  travelDateUpdate,
  setEditBookingTimeZone,
  travelTimeUpdateInput,
  travelTimeUpdate,
  isBookingEditable,
  isSinglebookingAffilate,
  affiliatePurchaseCurrencyinputChange,
  affiliatePurchasePriceinputChange,
  affiliateSelectOnChange,
  affiliateConatct,
  vehicleId,
  affiliateNoteinputChange,
  affiliatePurchaseCurrencyinput,
  affiliatePurchasePriceinput,
  affiliateNoteinput,
  isSingleBookingDriver,
  driverNameInput,
  driverName,
  driverContactInput,
  driverContact,
  isSingleBookingUploadInvoice,
  invoiceInputChnage,
  isEditEvent,
  startDateValue,
  endDateValue,
  markupValue,
  eventRegionName,
  eventNameValue,
  isEditCompany,
  companyEditAddressInput,
  companyEditAddressValue,
  companyCreditLimitInput,
  companyDiscountInput,
  companyMarkupInput,
  companyNameValue,
  companyEmailValue,
  companyWebsiteValue,
  companyAddressValue,
  companyGstValue,
  companyCreditLimitValue,
  companyDiscountValue,
  companyMarkupValue,
  companyLogoInput,
  isEditUser,
  userNameValue,
  firstNameValue,
  lastNameValue,
  emailInputValue,
  mobileNumberValue,
  userPermissionUpdate,
  setUserPermissionUpdate,
  isUpdatePassword,
  userUpdatePasswordInput,
  userUpdatePasswordValue,
  isSettings,
  isAddCard,
  cardNumberInput,
  cardHolderNameInput,
  cardBankNameInput,
  affiliateDetails,
  creditCards,
  affliateGlobalCheck,
  isLoggedOut,
  // Quote by Modal
  isQuoteBy,
}) => {
  const initialState = {
    newBookingState: false,
    manageBookingState: false,
    userManagementState: false,
  };

  const dispatch = useDispatch();
  const [permission, setPermission] = useState(initialState);
  const { eachUserDetails, companyDetails } = useSelector(
    (state) => state.company
  );
  const { allRegionsOrSearch } = useSelector((state) => state.region);
  const { DateExistsWithinEvent } = useSelector((state) => state.event);
  const [isRegionClicked, setIsRegionClicked] = useState(false);
  const [openContryCode, setopenContryCode] = useState(false);
  const { regions } = useSelector((state) => state.map);
  const [setFile] = useState();
  const { token, user } = useSelector((state) => state.auth);
  const [searchCountry, setSearchCountry] = useState("");
  const { activeAffiliates } = useSelector((state) => state.affiliate);
  const { transactionRecordStoreStatus } = useSelector(
    (state) => state.creditcard
  );
  const [newCategoryAdd, setNewCategoryAdd] = useState(false);
  const [vehicleCategoryNameInput, setVehicleCategoryNameInput] = useState();
  const [vehicleCategoryImageInput, setvehicleCategoryImageInput] = useState();
  const { bookingCredicards, allCreditCards } = useSelector(
    (state) => state.creditcard
  );
  const {
    bookingDetailsById,
    editBookingError,
    editBookingLoading,
    editBookingTime,
    editBookingDate,
    editBookingAllowed,
  } = useSelector((state) => state.booking);
  const [creditcard, setCreditcard] = useState(bookingDetailsById?.creditCards);
  const [matchdeleteWord, setmatchdeleteWord] = useState();
  const [country, setCountry] = useState();
  const [openCardDeleteModal, setopenCardDeleteModal] = useState(false);
  const [cardsToBeDeleted, setcardsToBeDeleted] = useState([]);
  const formDataVehicleCategory = new FormData();

  console.log("editBookingDate==>", editBookingDate);
  console.log("editBookingTime==>", editBookingTime);

  formDataVehicleCategory.append("name", vehicleCategoryNameInput);
  formDataVehicleCategory.append(
    "vehicleCategoryImage",
    vehicleCategoryImageInput
  );

  const [options, setoptions] = useState([]);
  const [flatRegions, setflatRegions] = useState([]);

  // user permission

  // let options = [];

  // const handleRegionAdd = () => {

  // };

  // useEffect(() => {
  //   handleRegionAdd();
  // }, []);

  const handleChange = (e) => {
    setFile(URL.createObjectURL(e.target.files[0]));
  };

  const flatRegionsList = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/flatregions/getAllFlatRegionsList`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = await response.json();

    data?.regionData?.forEach((region) => {
      setflatRegions((prev) => [
        ...prev,
        { value: region?._id, label: `${region?.name}` },
      ]);
      // options.unshift({ value: region._id, label: `${region.name} flatrate` });
      // console.log(region.name + " flatrate", "region");
      // options.push({ value: region._id, label: `${region.name} flatrate` });
    });
    allRegionsOrSearch.forEach((region) => {
      // options.push({ value: region._id, label: region.name });
      setoptions((prev) => [
        ...prev,
        { value: region?._id, label: region?.name },
      ]);
    });
  };

  useEffect(() => {
    flatRegionsList();
  }, []);

  useEffect(() => {
    dispatch({ type: "GET_REGIONS" });
    dispatch({ type: "GET_ALL_CREDIT_CARDS", payload: { token } });
  }, []);

  console.log(options, "options of regions");
  creditCardInitial = {};
  // useEffect(() => {
  //   if (bookingDetailsById?.creditCards) {
  //     bookingDetailsById?.creditCards?.forEach((card) => {
  //       _.map(creditcard, (value, key) => {
  //         if (card?.cardNumberLastFour === key) {
  //           creditCardInitial[key] = value;
  //
  //           setCreditcard(creditCardInitial);
  //         }
  //       });
  //     });
  //   }
  // }, [bookingDetailsById?.creditCards]);

  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  // const formattedYesterday = yesterday.toISOString().slice(0, 10);

  const formattedToday = moment().format("YYYY-MM-DD");

  useEffect(() => {
    if (setEditBookingTimeZone) {
      const currentDate = momenttz.tz(setEditBookingTimeZone).format();
      const utc24HoursAfter = momenttz(currentDate)
        .tz(setEditBookingTimeZone)
        .add(24, "hours")
        .format();
      // console.log("currentDate=====>", currentDate);
      // console.log("utc24HoursAfter=====>", utc24HoursAfter);

      const selected_date_time = `${momenttz
        .utc(editBookingDate && editBookingDate)
        .format("YYYY-MM-DD")}T${
        editBookingTime ? editBookingTime : bookingDetailsById?.travelTime
      }:00`;

      // console.log("selected_date_time=====>", selected_date_time);
      if (selected_date_time > utc24HoursAfter) {
        // console.log("ALLOWWWWWWWWW");
        if (DateExistsWithinEvent === false) {
          dispatch(
            setEditBookingError({
              editBookingError: "",
            })
          );
        }

        dispatch(
          setEditBookingAllowed({
            editBookingAllowed: true,
          })
        );
      } else {
        // console.log("DON'T ALLOWWWWWWWW");
        dispatch(
          setEditBookingError({
            editBookingError: "Date and time cannot be selected within 24hours",
          })
        );

        dispatch(
          setEditBookingAllowed({
            editBookingAllowed: false,
          })
        );
      }
    }
  }, [editBookingTime, editBookingDate]);

  return (
    <div className="animate__animated animate__fadeInDown fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
      <div className="relative w-full px-5 md:px-10 max-w-3xl mt-16 mb-10">
        {/*content*/}
        <div className="relative flex flex-col w-full bg-white border-0 rounded-lg shadow-lg outline-none focus:outline-none">
          {/*header*/}
          <div className="flex items-start justify-between p-5 border-b border-solid rounded-t border-slate-200">
            <h3 className="text-xl md:text-2xl font-medium text-[#fb4156]">
              {heading}
            </h3>
            <button
              className="float-right p-1 ml-auto text-3xl font-semibold leading-none text-black"
              onClick={cancelOnClick}
            >
              <span className="block w-6 h-6 -mt-4 -mr-2 text-2xl text-gray-600">
                ×
              </span>
            </button>
          </div>
          {/*body*/}
          <div>
            {isAddUser && (
              <div className="relative flex-auto p-6 space-y-3">
                <div>
                  <ModalInputField
                    labelName="User Name (email id)"
                    type="text"
                    placeholder="Enter User Name (email id)"
                    fontawesomeIcon={faUser}
                    onChange={userNameInput}
                    onBlur={() => {
                      // check user name with email validatio regex
                      if (userNameInput) {
                        const emailRegex =
                          /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
                        if (!emailRegex.test(userNameInput)) {
                          toast.warning(
                            "Please enter valid username (email id)",
                            {
                              // position: "top-center",
                              autoClose: 4000,
                            }
                          );
                        }
                      }
                    }}
                  />
                </div>
                <div className="sm:flex py-2 sm:space-x-10">
                  <div className="w-full grow">
                    <ModalInputField
                      labelName="First Name"
                      type="text"
                      fontawesomeIcon={faUser}
                      placeholder="Enter Name"
                      onChange={firstNameInput}
                    />
                  </div>
                  <div className="w-full grow mt-5 sm:mt-0">
                    <ModalInputField
                      labelName="Last Name"
                      type="text"
                      fontawesomeIcon={faUser}
                      placeholder="Enter Name"
                      onChange={lastNameInput}
                    />
                  </div>
                </div>
                <div className="sm:flex sm:space-x-10">
                  <div className="w-full grow">
                    <ModalInputField
                      labelName="Email"
                      type="email"
                      fontawesomeIcon={faEnvelope}
                      placeholder="Enter Email"
                      onChange={emailInput}
                    />
                  </div>
                  <div className="w-full grow mt-5 sm:mt-0">
                    <ModalInputField
                      labelName="Mobile Number"
                      type="number"
                      fontawesomeIcon={faPhone}
                      placeholder="Enter mobile number"
                      onChange={mobileNumberInput}
                    />
                  </div>
                </div>
                <div className="sm:flex py-2 sm:space-x-10">
                  <div className="w-full grow">
                    <ModalInputField
                      labelName="Password"
                      type="text"
                      fontawesomeIcon={faKey}
                      placeholder="Enter Password "
                      onChange={passwordInput}
                    />
                  </div>
                  <div className="w-full grow mt-5 sm:mt-0">
                    <ModalInputField
                      labelName="Confirm Password"
                      type="text"
                      fontawesomeIcon={faKey}
                      placeholder="Enter Confirm Password"
                      onChange={confirmPasswordInput}
                      onBlur={() => {
                        if (passwordInput !== confirmPasswordInput) {
                          toast.warning(
                            "Password and confirm password should be same",
                            {
                              autoClose: 4000,
                            }
                          );
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
            {isUpdatePassword && (
              <>
                <div className="relative flex-auto p-6 space-y-3">
                  <div className="text-gray-700">
                    <ModalInputField
                      labelName=" Password"
                      type="text"
                      placeholder="Enter New Password"
                      fontawesomeIcon={faLock}
                      onChange={userUpdatePasswordInput}
                      inputvalue={userUpdatePasswordValue}
                    />
                  </div>
                </div>
              </>
            )}
            {isEditUser && (
              <>
                <div className="relative flex-auto p-6 space-y-3">
                  <div className="text-gray-700">
                    <ModalInputField
                      labelName="User Name"
                      type="text"
                      placeholder="Enter User Name"
                      fontawesomeIcon={faUser}
                      onChange={userNameInput}
                      inputvalue={userNameValue}
                    />
                  </div>
                  <div className="flex py-2 space-x-10">
                    <div className="w-full text-gray-700 grow">
                      <ModalInputField
                        labelName="First Name"
                        type="text"
                        fontawesomeIcon={faUser}
                        placeholder="Enter Name"
                        onChange={firstNameInput}
                        inputvalue={firstNameValue}
                      />
                    </div>
                    <div className="w-full text-gray-700 grow">
                      <ModalInputField
                        labelName="Last Name"
                        type="text"
                        fontawesomeIcon={faUser}
                        placeholder="Enter Name"
                        onChange={lastNameInput}
                        inputvalue={lastNameValue}
                      />
                    </div>
                  </div>
                  <div className="flex space-x-10">
                    <div className="w-full text-gray-700 grow">
                      <ModalInputField
                        labelName="Email"
                        type="email"
                        fontawesomeIcon={faEnvelope}
                        placeholder="Enter Email"
                        onChange={emailInput}
                        inputvalue={emailInputValue}
                      />
                    </div>
                    <div className="w-full text-gray-700 grow">
                      <ModalInputField
                        labelName="Mobile Number"
                        type="number"
                        fontawesomeIcon={faPhone}
                        placeholder="Enter mobile number"
                        onChange={mobileNumberInput}
                        inputvalue={mobileNumberValue}
                      />
                    </div>
                  </div>
                  <div className="flex space-x-10">
                    <div className="w-full text-gray-700 grow">
                      <ModalInputField
                        labelName="Mark up"
                        type="number"
                        fontawesomeIcon={faEnvelope}
                        placeholder="Enter Markup"
                        onChange={usermarkupInput}
                        inputvalue={usermarkupInputValue}
                      />
                    </div>
                    <div className="w-full text-gray-700 grow">
                      <ModalInputField
                        labelName="Discount"
                        type="number"
                        fontawesomeIcon={faPercent}
                        placeholder="Enter Discount"
                        onChange={userDiscountInput}
                        inputvalue={userDiscountValue}
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
            {isAddCompany && (
              <div className="relative flex-auto p-6 space-y-3">
                <div>
                  <ModalInputField
                    labelName="Company Name *"
                    type="text"
                    placeholder="Enter Company Name"
                    fontawesomeIcon={faBuilding}
                    onChange={companyNameInput}
                  />
                </div>
                <div className="sm:flex py-2 sm:space-x-10">
                  <div className="w-full grow">
                    <ModalInputField
                      labelName="Company Email Address *"
                      type="email"
                      placeholder="Enter company email address"
                      fontawesomeIcon={faEnvelope}
                      onChange={companyEmailInput}
                    />
                  </div>
                  <div className="w-full grow mt-5 sm:mt-0">
                    <ModalInputField
                      labelName="Website (optional)"
                      type="text"
                      placeholder="Enter  website"
                      fontawesomeIcon={faGlobe}
                      onChange={companyWebsiteInput}
                    />
                  </div>
                </div>
                <div className="w-full grow">
                  <ModalInputField
                    labelName="Address (optional)"
                    type="textarea"
                    placeholder="Enter address"
                    fontawesomeIcon={faLocationDot}
                    onChange={companyAddressInput}
                  />
                </div>
                <div className="w-full grow">
                  <ModalInputField
                    labelName="GST / VAT (optional)"
                    type="text"
                    placeholder="Enter GST / VAT"
                    fontawesomeIcon={faEnvelope}
                    onChange={companyGstInput}
                  />
                </div>
              </div>
            )}
            {isPermission && (
              <>
                <div className="mt-3 ml-3 overflow-y-auto h-96 scrollbar">
                  <div>
                    <div className="flex items-center pt-5">
                      {permission.newBookingState ? (
                        <ChevronDownIcon
                          className="w-5"
                          onClick={() => {
                            setPermission({
                              ...permission,
                              newBookingState: false,
                            });
                          }}
                        />
                      ) : (
                        <ChevronRightIcon
                          className="w-5"
                          onClick={() => {
                            setPermission({
                              ...permission,
                              newBookingState: true,
                            });
                          }}
                        />
                      )}
                      <PermissionInput
                        permissionName="New Booking"
                        diasableId="newBookingDisable"
                        enableId="newBookingEnable"
                        readId="newBookingRead"
                        isRestrict={false}
                        isReadOnly={true}
                        name="newBooking"
                        permission={
                          userPermissionUpdate?.newBooking?.permission
                            ? userPermissionUpdate?.newBooking?.permission
                            : eachUserDetails?.permission?.newBooking
                                ?.permission
                        }
                        onClick={(e) => {
                          if (e.target.id === "newBookingDisable") {
                            setUserPermissionUpdate({
                              ...userPermissionUpdate,
                              newBooking: {
                                ...userPermissionUpdate?.newBooking,
                                permission: "DISABLE",
                              },
                            });
                          }
                          if (e.target.id === "newBookingEnable") {
                            setUserPermissionUpdate({
                              ...userPermissionUpdate,
                              newBooking: {
                                ...userPermissionUpdate?.newBooking,
                                permission: "ENABLE",
                              },
                            });
                          }
                          if (e.target.id === "newBookingRead") {
                            setUserPermissionUpdate({
                              ...userPermissionUpdate,
                              newBooking: {
                                ...userPermissionUpdate?.newBooking,
                                permission: "READ_ONLY",
                              },
                            });
                          }
                        }}
                      />
                    </div>
                    {permission.newBookingState && (
                      <div className="animate__animated animate__slideInLeft pt-0 pl-16 my-2 space-y-0">
                        <div className=" flex items-center">
                          <FontAwesomeIcon
                            icon={faArrowTurnUp}
                            className="rotate-90"
                          />
                          <PermissionInput
                            permissionName="Perform Search"
                            diasableId="newBookingPerformSearchDisable"
                            enableId="newBookingPerformSearchEnable"
                            name="newBookingPerformSearch"
                            isReadOnly={false}
                            isRestrict={false}
                            permission={
                              userPermissionUpdate?.newBooking?.performSearch
                                ? userPermissionUpdate?.newBooking
                                    ?.performSearch.permission
                                : eachUserDetails?.permission?.newBooking
                                    ?.performSearch?.permission
                            }
                            onClick={(e) => {
                              if (
                                e.target.id === "newBookingPerformSearchDisable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  newBooking: {
                                    ...userPermissionUpdate?.newBooking,
                                    performSearch: {
                                      permission: "DISABLE",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id === "newBookingPerformSearchEnable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  newBooking: {
                                    ...userPermissionUpdate?.newBooking,
                                    performSearch: {
                                      permission: "ENABLE",
                                    },
                                  },
                                });
                              }
                            }}
                          />
                        </div>
                        <div className="flex items-center">
                          <FontAwesomeIcon
                            icon={faArrowTurnUp}
                            className="rotate-90"
                          />
                          <PermissionInput
                            permissionName="Make Booking"
                            diasableId="newBookingMakeBookingDisable"
                            enableId="newBookingMakeBookingEnable"
                            isReadOnly={false}
                            isRestrict={false}
                            name="newBookingMakeBooking"
                            permission={
                              userPermissionUpdate?.newBooking?.MakeBooking
                                ? userPermissionUpdate?.newBooking.MakeBooking
                                    .permission
                                : eachUserDetails?.permission?.newBooking
                                    ?.MakeBooking?.permission
                            }
                            onClick={(e) => {
                              if (
                                e.target.id === "newBookingMakeBookingDisable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  newBooking: {
                                    ...userPermissionUpdate?.newBooking,
                                    MakeBooking: {
                                      permission: "DISABLE",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id === "newBookingMakeBookingEnable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  newBooking: {
                                    ...userPermissionUpdate?.newBooking,
                                    MakeBooking: {
                                      permission: "ENABLE",
                                    },
                                  },
                                });
                              }
                            }}
                          />
                        </div>
                        <div className="flex items-center">
                          <FontAwesomeIcon
                            icon={faArrowTurnUp}
                            className="rotate-90"
                          />
                          <PermissionInput
                            permissionName="Requested Booking"
                            diasableId="newBookingHoldBookingDisable"
                            enableId="newBookingHoldBookingEnable"
                            isReadOnly={false}
                            isRestrict={false}
                            name="newBookingHoldBooking"
                            permission={
                              userPermissionUpdate?.newBooking?.Requestbooking
                                ? userPermissionUpdate?.newBooking
                                    .Requestbooking.permission
                                : eachUserDetails?.permission?.newBooking
                                    ?.Requestbooking?.permission
                            }
                            onClick={(e) => {
                              if (
                                e.target.id === "newBookingHoldBookingDisable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  newBooking: {
                                    ...userPermissionUpdate?.newBooking,
                                    Requestbooking: {
                                      permission: "DISABLE",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id === "newBookingHoldBookingEnable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  newBooking: {
                                    ...userPermissionUpdate?.newBooking,
                                    Requestbooking: {
                                      permission: "ENABLE",
                                    },
                                  },
                                });
                              }
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="ml-5">
                    <PermissionInput
                      permissionName="Flat Rate"
                      diasableId="flatRateDisable"
                      enableId="flatRateEnable"
                      readId="flatRateRead"
                      name="flatRate"
                      isRestrict={false}
                      isReadOnly={true}
                      permission={
                        userPermissionUpdate?.flatRateBooking?.permission
                          ? userPermissionUpdate?.flatRateBooking.permission
                          : eachUserDetails?.permission?.flatRateBooking
                      }
                      onClick={(e) => {
                        if (e.target.id === "flatRateDisable") {
                          setUserPermissionUpdate({
                            ...userPermissionUpdate,
                            flatRateBooking: {
                              permission: "DISABLE",
                            },
                          });
                        }
                        if (e.target.id === "flatRateEnable") {
                          setUserPermissionUpdate({
                            ...userPermissionUpdate,
                            flatRateBooking: {
                              permission: "ENABLE",
                            },
                          });
                        }
                        if (e.target.id === "flatRateRead") {
                          setUserPermissionUpdate({
                            ...userPermissionUpdate,
                            flatRateBooking: {
                              permission: "READ",
                            },
                          });
                        }
                      }}
                    />
                  </div>
                  <div>
                    <div className="flex items-center">
                      {permission.manageBookingState ? (
                        <ChevronDownIcon
                          className="w-5"
                          onClick={() => {
                            setPermission({
                              ...permission,
                              manageBookingState: false,
                            });
                          }}
                        />
                      ) : (
                        <ChevronRightIcon
                          className="w-5"
                          onClick={() => {
                            setPermission({
                              ...permission,
                              manageBookingState: true,
                            });
                          }}
                        />
                      )}

                      <PermissionInput
                        permissionName="Manage Booking"
                        diasableId="manageBookingDisable"
                        enableId="manageBookingEnable"
                        readId="manageBookingRead"
                        name="manageBooking"
                        isRestrict={false}
                        isReadOnly={true}
                        permission={
                          userPermissionUpdate?.manageBooking?.permission
                            ? userPermissionUpdate?.manageBooking.permission
                            : eachUserDetails?.permission?.manageBooking
                                ?.permission
                        }
                        onClick={(e) => {
                          if (e.target.id === "manageBookingDisable") {
                            setUserPermissionUpdate({
                              ...userPermissionUpdate,
                              manageBooking: {
                                permission: "DISABLE",
                              },
                            });
                          }
                          if (e.target.id === "manageBookingEnable") {
                            setUserPermissionUpdate({
                              ...userPermissionUpdate,
                              manageBooking: {
                                permission: "ENABLE",
                              },
                            });
                          }
                          if (e.target.id === "manageBookingRead") {
                            setUserPermissionUpdate({
                              ...userPermissionUpdate,
                              manageBooking: {
                                permission: "READ_ONLY",
                              },
                            });
                          }
                        }}
                      />
                    </div>
                    {permission.manageBookingState && (
                      <div className="animate__animated animate__slideInLeft pl-16">
                        <div className="flex items-center">
                          <FontAwesomeIcon
                            icon={faArrowTurnUp}
                            className="rotate-90"
                          />
                          <PermissionInput
                            permissionName="View Bookings"
                            diasableId="manageBookingViewBookingsDisable"
                            enableId="manageBookingViewBookingsEnable"
                            branchLevelId="manageBookingViewBookingsBranchLevel"
                            childCompanyId="manageBookingViewBookingsChildCompany"
                            name="viewBookings"
                            isReadOnly={false}
                            isRestrict={true}
                            permission={
                              userPermissionUpdate?.manageBooking?.viewBooking
                                ? userPermissionUpdate?.manageBooking
                                    ?.viewBooking.permission
                                : eachUserDetails?.permission?.manageBooking
                                    ?.viewBooking?.permission
                            }
                            onClick={(e) => {
                              if (
                                e.target.id ===
                                "manageBookingViewBookingsDisable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    viewBooking: {
                                      permission: "DISABLE",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id ===
                                "manageBookingViewBookingsEnable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    viewBooking: {
                                      permission: "ENABLE",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id ===
                                "manageBookingViewBookingsBranchLevel"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    viewBooking: {
                                      permission: "BRANCH_LEVEL",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id ===
                                "manageBookingViewBookingsChildCompany"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    viewBooking: {
                                      permission: "CHILD_COMPANY",
                                    },
                                  },
                                });
                              }
                            }}
                          />
                        </div>
                        <div className="flex items-center">
                          <FontAwesomeIcon
                            icon={faArrowTurnUp}
                            className="rotate-90"
                          />
                          <PermissionInput
                            permissionName="Approve Bookings"
                            diasableId="manageBookingApproveBookingsDisable"
                            enableId="manageBookingApproveBookingsEnable"
                            branchLevelId="manageBookingApproveBookingsBranchLevel"
                            childCompanyId="manageBookingApproveBookingsChildCompany"
                            isReadOnly={false}
                            isRestrict={true}
                            name="manageBookingApproveBookings"
                            permission={
                              userPermissionUpdate?.manageBooking
                                ?.approveBooking
                                ? userPermissionUpdate?.manageBooking
                                    ?.approveBooking?.permission
                                : eachUserDetails?.permission?.manageBooking
                                    ?.approveBooking?.permission
                            }
                            onClick={(e) => {
                              if (
                                e.target.id ===
                                "manageBookingApproveBookingsDisable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    approveBooking: {
                                      permission: "DISABLE",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id ===
                                "manageBookingApproveBookingsEnable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    approveBooking: {
                                      permission: "ENABLE",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id ===
                                "manageBookingApproveBookingsBranchLevel"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    approveBooking: {
                                      permission: "BRANCH_LEVEL",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id ===
                                "manageBookingApproveBookingsChildCompany"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    approveBooking: {
                                      permission: "CHILD_COMPANY",
                                    },
                                  },
                                });
                              }
                            }}
                          />
                        </div>

                        <div className="flex items-center">
                          <FontAwesomeIcon
                            icon={faArrowTurnUp}
                            className="rotate-90"
                          />
                          <PermissionInput
                            permissionName="Edit Bookings"
                            diasableId="manageBookingEditBookingsDisable"
                            enableId="manageBookingEditBookingsEnable"
                            branchLevelId="manageBookingEditBookingsBranchLevel"
                            childCompanyId="manageBookingEditBookingsChildCompany"
                            isReadOnly={false}
                            isRestrict={true}
                            name="manageBookingEditBookings"
                            permission={
                              userPermissionUpdate?.manageBooking?.editBooking
                                ? userPermissionUpdate?.manageBooking
                                    ?.editBooking?.permission
                                : eachUserDetails?.permission?.manageBooking
                                    ?.editBooking?.permission
                            }
                            onClick={(e) => {
                              if (
                                e.target.id ===
                                "manageBookingEditBookingsDisable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    editBooking: {
                                      permission: "DISABLE",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id ===
                                "manageBookingEditBookingsEnable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    editBooking: {
                                      permission: "ENABLE",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id ===
                                "manageBookingEditBookingsBranchLevel"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    editBooking: {
                                      permission: "BRANCH_LEVEL",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id ===
                                "manageBookingEditBookingsChildCompany"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    editBooking: {
                                      permission: "CHILD_COMPANY",
                                    },
                                  },
                                });
                              }
                            }}
                          />
                        </div>

                        <div className="flex items-center">
                          <FontAwesomeIcon
                            icon={faArrowTurnUp}
                            className="rotate-90"
                          />
                          <PermissionInput
                            permissionName="Cancel request booking"
                            diasableId="manageBookingCancelRequestBookingsDisable"
                            enableId="manageBookingCancelRequestBookingsEnable"
                            branchLevelId="manageBookingCancelRequestBookingsBranchLevel"
                            childCompanyId="manageBookingCancelRequestBookingsChildCompany"
                            isReadOnly={false}
                            isRestrict={true}
                            name="manageBookingCancelRequestBookings"
                            permission={
                              userPermissionUpdate?.manageBooking
                                ?.cancelRequestBooking
                                ? userPermissionUpdate?.manageBooking
                                    ?.cancelRequestBooking?.permission
                                : eachUserDetails?.permission?.manageBooking
                                    ?.cancelRequestBooking?.permission
                            }
                            onClick={(e) => {
                              if (
                                e.target.id ===
                                "manageBookingCancelRequestBookingsDisable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    cancelRequestBooking: {
                                      permission: "DISABLE",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id ===
                                "manageBookingCancelRequestBookingsEnable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    cancelRequestBooking: {
                                      permission: "ENABLE",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id ===
                                "manageBookingCancelRequestBookingsBranchLevel"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    cancelRequestBooking: {
                                      permission: "BRANCH_LEVEL",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id ===
                                "manageBookingCancelRequestBookingsChildCompany"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    cancelRequestBooking: {
                                      permission: "CHILD_COMPANY",
                                    },
                                  },
                                });
                              }
                            }}
                          />
                        </div>

                        <div className="flex items-center">
                          <FontAwesomeIcon
                            icon={faArrowTurnUp}
                            className="rotate-90"
                          />
                          <PermissionInput
                            permissionName="Cancel Bookings"
                            diasableId="manageBookingCancelBookingsDisable"
                            enableId="manageBookingCancelBookingsEnable"
                            branchLevelId="manageBookingCancelBookingsBranchLevel"
                            childCompanyId="manageBookingCancelBookingsChildCompany"
                            isReadOnly={false}
                            isRestrict={true}
                            name="manageBookingCancelBookings"
                            permission={
                              userPermissionUpdate?.manageBooking?.cancelBooking
                                ? userPermissionUpdate?.manageBooking
                                    ?.cancelBooking?.permission
                                : eachUserDetails?.permission?.manageBooking
                                    ?.cancelBooking?.permission
                            }
                            onClick={(e) => {
                              if (
                                e.target.id ===
                                "manageBookingCancelBookingsDisable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    cancelBooking: {
                                      permission: "DISABLE",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id ===
                                "manageBookingCancelBookingsEnable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    cancelBooking: {
                                      permission: "ENABLE",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id ===
                                "manageBookingCancelBookingsBranchLevel"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    cancelBooking: {
                                      permission: "BRANCH_LEVEL",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id ===
                                "manageBookingCancelBookingsChildCompany"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    cancelBooking: {
                                      permission: "CHILD_COMPANY",
                                    },
                                  },
                                });
                              }
                            }}
                          />
                        </div>
                        <div className="flex items-center">
                          <FontAwesomeIcon
                            icon={faArrowTurnUp}
                            className="rotate-90"
                          />
                          <PermissionInput
                            permissionName="Assign Affiliate"
                            diasableId="manageBookingAssignAffiliateDisable"
                            enableId="manageBookingAssignAffiliateEnable"
                            branchLevelId="manageBookingAssignAffiliateBranchLevel"
                            childCompanyId="manageBookingAssignAffiliateChildCompany"
                            isReadOnly={false}
                            isRestrict={true}
                            name="manageBookingAssignAffiliate"
                            permission={
                              userPermissionUpdate?.manageBooking
                                ?.assignAffiliate
                                ? userPermissionUpdate?.manageBooking
                                    ?.assignAffiliate?.permission
                                : eachUserDetails?.permission?.manageBooking
                                    ?.assignAffiliate?.permission
                            }
                            onClick={(e) => {
                              if (
                                e.target.id ===
                                "manageBookingAssignAffiliateDisable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    assignAffiliate: {
                                      permission: "DISABLE",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id ===
                                "manageBookingAssignAffiliateEnable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    assignAffiliate: {
                                      permission: "ENABLE",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id ===
                                "manageBookingAssignAffiliateBranchLevel"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    assignAffiliate: {
                                      permission: "BRANCH_LEVEL",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id ===
                                "manageBookingAssignAffiliateChildCompany"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    assignAffiliate: {
                                      permission: "CHILD_COMPANY",
                                    },
                                  },
                                });
                              }
                            }}
                          />
                        </div>
                        <div className="flex items-center">
                          <FontAwesomeIcon
                            icon={faArrowTurnUp}
                            className="rotate-90"
                          />
                          <PermissionInput
                            permissionName="Assign Driver"
                            diasableId="manageBookingAssignDriverDisable"
                            enableId="manageBookingAssignDriverEnable"
                            branchLevelId="manageBookingAssignDriverBranchLevel"
                            childCompanyId="manageBookingAssignDriverChildCompany"
                            isReadOnly={false}
                            isRestrict={true}
                            name="manageBookingAssignDriver"
                            permission={
                              userPermissionUpdate?.manageBooking?.assignDriver
                                ? userPermissionUpdate?.manageBooking
                                    ?.assignDriver?.permission
                                : eachUserDetails?.permission?.manageBooking
                                    ?.assignDriver?.permission
                            }
                            onClick={(e) => {
                              if (
                                e.target.id ===
                                "manageBookingAssignDriverDisable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    assignDriver: {
                                      permission: "DISABLE",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id ===
                                "manageBookingAssignDriverEnable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    assignDriver: {
                                      permission: "ENABLE",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id ===
                                "manageBookingAssignDriverBranchLevel"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    assignDriver: {
                                      permission: "BRANCH_LEVEL",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id ===
                                "manageBookingAssignDriverChildCompany"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    assignDriver: {
                                      permission: "CHILD_COMPANY",
                                    },
                                  },
                                });
                              }
                            }}
                          />
                        </div>
                        <div className="flex items-center">
                          <FontAwesomeIcon
                            icon={faArrowTurnUp}
                            className="rotate-90"
                          />
                          <PermissionInput
                            permissionName="Mark As Paid"
                            diasableId="manageBookingMarkAsPaidDisable"
                            enableId="manageBookingMarkAsPaidEnable"
                            branchLevelId="manageBookingMarkAsPaidBranchLevel"
                            childCompanyId="manageBookingMarkAsPaidChildCompany"
                            isReadOnly={false}
                            isRestrict={true}
                            name="manageBookingMarkAsPaid"
                            permission={
                              userPermissionUpdate?.manageBooking?.markAsPaid
                                ? userPermissionUpdate?.manageBooking
                                    ?.markAsPaid?.permission
                                : eachUserDetails?.permission?.manageBooking
                                    ?.markAsPaid?.permission
                            }
                            onClick={(e) => {
                              if (
                                e.target.id === "manageBookingMarkAsPaidDisable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    markAsPaid: {
                                      permission: "DISABLE",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id === "manageBookingMarkAsPaidEnable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    markAsPaid: {
                                      permission: "ENABLE",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id ===
                                "manageBookingMarkAsPaidBranchLevel"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    markAsPaid: {
                                      permission: "BRANCH_LEVEL",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id ===
                                "manageBookingMarkAsPaidChildCompany"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    markAsPaid: {
                                      permission: "CHILD_COMPANY",
                                    },
                                  },
                                });
                              }
                            }}
                          />
                        </div>
                        <div className="flex items-center">
                          <FontAwesomeIcon
                            icon={faArrowTurnUp}
                            className="rotate-90"
                          />
                          <PermissionInput
                            permissionName="SMS / Document"
                            diasableId="manageBookingSMSDocumentDisable"
                            enableId="manageBookingSMSDocumentEnable"
                            branchLevelId="manageBookingSMSDocumentBranchLevel"
                            childCompanyId="manageBookingSMSDocumentChildCompany"
                            isReadOnly={false}
                            isRestrict={true}
                            name="SMSDocument"
                            permission={
                              userPermissionUpdate?.manageBooking?.sms_Document
                                ? userPermissionUpdate?.manageBooking
                                    ?.sms_Document?.permission
                                : eachUserDetails?.permission?.manageBooking
                                    ?.sms_Document?.permission
                            }
                            onClick={(e) => {
                              if (
                                e.target.id ===
                                "manageBookingSMSDocumentDisable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    sms_Document: {
                                      permission: "DISABLE",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id === "manageBookingSMSDocumentEnable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    sms_Document: {
                                      permission: "ENABLE",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id ===
                                "manageBookingSMSDocumentBranchLevel"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    sms_Document: {
                                      permission: "BRANCH_LEVEL",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id ===
                                "manageBookingSMSDocumentChildCompany"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    sms_Document: {
                                      permission: "CHILD_COMPANY",
                                    },
                                  },
                                });
                              }
                            }}
                          />
                        </div>
                        <div className="flex items-center">
                          <FontAwesomeIcon
                            icon={faArrowTurnUp}
                            className="rotate-90"
                          />
                          <PermissionInput
                            permissionName="Fin Ammendment"
                            diasableId="manageBookingFinAmmendmentDisable"
                            enableId="manageBookingFinAmmendmentEnable"
                            isReadOnly={false}
                            isRestrict={true}
                            name="finAmmendment"
                            permission={
                              userPermissionUpdate?.manageBooking?.finAmmendment
                                ? userPermissionUpdate?.manageBooking
                                    ?.finAmmendment?.permission
                                : eachUserDetails?.permission?.manageBooking
                                    ?.finAmmendment?.permission
                            }
                            onClick={(e) => {
                              if (
                                e.target.id ===
                                "manageBookingFinAmmendmentDisable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    finAmmendment: {
                                      permission: "DISABLE",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id ===
                                "manageBookingFinAmmendmentEnable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    finAmmendment: {
                                      permission: "ENABLE",
                                    },
                                  },
                                });
                              }
                            }}
                          />
                        </div>

                        <div className="flex items-center">
                          <FontAwesomeIcon
                            icon={faArrowTurnUp}
                            className="rotate-90"
                          />
                          <PermissionInput
                            permissionName="Ops Ammendment"
                            diasableId="manageBookingOpsAmmendmentDisable"
                            enableId="manageBookingOpsAmmendmentEnable"
                            isReadOnly={false}
                            isRestrict={true}
                            name="opsAmmendment"
                            permission={
                              userPermissionUpdate?.manageBooking?.opsAmmendment
                                ? userPermissionUpdate?.manageBooking
                                    ?.opsAmmendment?.permission
                                : eachUserDetails?.permission?.manageBooking
                                    ?.opsAmmendment?.permission
                            }
                            onClick={(e) => {
                              if (
                                e.target.id ===
                                "manageBookingOpsAmmendmentDisable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    opsAmmendment: {
                                      permission: "DISABLE",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id ===
                                "manageBookingOpsAmmendmentEnable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  manageBooking: {
                                    ...userPermissionUpdate?.manageBooking,
                                    opsAmmendment: {
                                      permission: "ENABLE",
                                    },
                                  },
                                });
                              }
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  <div>
                    <div className="flex items-center">
                      <div className="w-5"></div>
                      <PermissionInput
                        permissionName="Affiliate"
                        diasableId="affiliateDisable"
                        enableId="affiliateEnable"
                        readId="affiliateRead"
                        name="affiliate"
                        isReadOnly={true}
                        permission={
                          userPermissionUpdate?.affiliate
                            ? userPermissionUpdate?.affiliate?.permission
                            : eachUserDetails?.permission?.affiliate?.permission
                        }
                        onClick={(e) => {
                          if (e.target.id === "affiliateDisable") {
                            setUserPermissionUpdate({
                              ...userPermissionUpdate,
                              affiliate: {
                                permission: "DISABLE",
                              },
                            });
                          }
                          if (e.target.id === "affiliateEnable") {
                            setUserPermissionUpdate({
                              ...userPermissionUpdate,
                              affiliate: {
                                permission: "ENABLE",
                              },
                            });
                          }
                          if (e.target.id === "affiliateRead") {
                            setUserPermissionUpdate({
                              ...userPermissionUpdate,
                              affiliate: {
                                permission: "READ_ONLY",
                              },
                            });
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    <div className="flex items-center">
                      <div className="w-5"></div>
                      <PermissionInput
                        permissionName="Regions"
                        diasableId="regionsDisable"
                        enableId="regionsEnable"
                        readId="regionsRead"
                        name="regions"
                        isReadOnly={true}
                        permission={
                          userPermissionUpdate?.regions?.permission
                            ? userPermissionUpdate?.regions?.permission
                            : eachUserDetails?.permission?.regions?.permission
                        }
                        onClick={(e) => {
                          if (e.target.id === "regionsDisable") {
                            setUserPermissionUpdate({
                              ...userPermissionUpdate,
                              regions: {
                                permission: "DISABLE",
                              },
                            });
                          }
                          if (e.target.id === "regionsEnable") {
                            setUserPermissionUpdate({
                              ...userPermissionUpdate,
                              regions: {
                                permission: "ENABLE",
                              },
                            });
                          }
                          if (e.target.id === "regionsRead") {
                            setUserPermissionUpdate({
                              ...userPermissionUpdate,
                              regions: {
                                permission: "READ_ONLY",
                              },
                            });
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    <div className="flex items-center">
                      <div className="w-5"></div>
                      <PermissionInput
                        permissionName="Flat Regions"
                        diasableId="flatRegionsDisable"
                        enableId="flatRegionsEnable"
                        readId="flatRegionsRead"
                        name="flatRegions"
                        isReadOnly={true}
                        permission={
                          userPermissionUpdate?.flatRegions?.permission
                            ? userPermissionUpdate?.flatRegions?.permission
                            : eachUserDetails?.permission?.flatRegions
                                ?.permission
                        }
                        onClick={(e) => {
                          if (e.target.id === "flatRegionsDisable") {
                            setUserPermissionUpdate({
                              ...userPermissionUpdate,
                              flatRegions: {
                                permission: "DISABLE",
                              },
                            });
                          }
                          if (e.target.id === "flatRegionsEnable") {
                            setUserPermissionUpdate({
                              ...userPermissionUpdate,
                              flatRegions: {
                                permission: "ENABLE",
                              },
                            });
                          }
                          if (e.target.id === "flatRegionsRead") {
                            setUserPermissionUpdate({
                              ...userPermissionUpdate,
                              flatRegions: {
                                permission: "READ_ONLY",
                              },
                            });
                          }
                        }}
                      />
                    </div>
                  </div>

                  <div>
                    <div className="flex items-center">
                      <div className="w-5"></div>
                      <PermissionInput
                        permissionName="General Settings"
                        diasableId="generalSettingsDisable"
                        enableId="generalSettingsEnable"
                        readId="generalSettingsRead"
                        name="generalSettings"
                        isReadOnly={true}
                        permission={
                          userPermissionUpdate?.generalSettings?.permission
                            ? userPermissionUpdate?.generalSettings?.permission
                            : eachUserDetails?.permission?.generalSettings
                                ?.permission
                        }
                        onClick={(e) => {
                          if (e.target.id === "generalSettingsDisable") {
                            setUserPermissionUpdate({
                              ...userPermissionUpdate,
                              generalSettings: {
                                permission: "DISABLE",
                              },
                            });
                          }
                          if (e.target.id === "generalSettingsEnable") {
                            setUserPermissionUpdate({
                              ...userPermissionUpdate,
                              generalSettings: {
                                permission: "ENABLE",
                              },
                            });
                          }
                          if (e.target.id === "generalSettingsRead") {
                            setUserPermissionUpdate({
                              ...userPermissionUpdate,
                              generalSettings: {
                                permission: "READ_ONLY",
                              },
                            });
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    <div className="flex items-center">
                      {permission.manageUsersState ? (
                        <ChevronDownIcon
                          className="w-5"
                          onClick={() => {
                            setPermission({
                              ...permission,
                              manageUsersState: false,
                            });
                          }}
                        />
                      ) : (
                        <ChevronRightIcon
                          className="w-5"
                          onClick={() => {
                            setPermission({
                              ...permission,
                              manageUsersState: true,
                            });
                          }}
                        />
                      )}

                      <PermissionInput
                        permissionName="User Management"
                        diasableId="userManagementDisable"
                        enableId="userManagementEnable"
                        readId="userManagementRead"
                        name="userManagement"
                        isReadOnly={true}
                        permission={
                          userPermissionUpdate?.userManagement?.permission
                            ? userPermissionUpdate?.userManagement?.permission
                            : eachUserDetails?.permission?.userManagement
                                ?.permission
                        }
                        onClick={(e) => {
                          if (e.target.id === "userManagementDisable") {
                            setUserPermissionUpdate({
                              ...userPermissionUpdate,
                              userManagement: {
                                permission: "DISABLE",
                              },
                            });
                          }
                          if (e.target.id === "userManagementEnable") {
                            setUserPermissionUpdate({
                              ...userPermissionUpdate,
                              userManagement: {
                                permission: "ENABLE",
                              },
                            });
                          }
                          if (e.target.id === "userManagementRead") {
                            setUserPermissionUpdate({
                              ...userPermissionUpdate,
                              userManagement: {
                                permission: "READ_ONLY",
                              },
                            });
                          }
                        }}
                      />
                    </div>
                    {permission.manageUsersState && (
                      <div className="animate__animated animate__slideInLeft pl-16">
                        <div className="flex items-center">
                          <FontAwesomeIcon
                            icon={faArrowTurnUp}
                            className="rotate-90"
                          />
                          <PermissionInput
                            permissionName="View Users"
                            diasableId="userManagementViewUsersDisable"
                            enableId="userManagementViewUsersEnable"
                            branchLevelId="userManagementViewUsersBranchLevel"
                            childCompanyId="userManagementViewUsersChildCompany"
                            isReadOnly={false}
                            isRestrict={true}
                            name="userManagementViewUsers"
                            permission={
                              userPermissionUpdate?.userManagement?.view
                                ? userPermissionUpdate?.userManagement?.view
                                    ?.permission
                                : eachUserDetails?.permission?.userManagement
                                    ?.view?.permission
                            }
                            onClick={(e) => {
                              if (
                                e.target.id === "userManagementViewUsersDisable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  userManagement: {
                                    ...userPermissionUpdate?.userManagement,
                                    view: {
                                      permission: "DISABLE",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id === "userManagementViewUsersEnable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  userManagement: {
                                    ...userPermissionUpdate?.userManagement,
                                    view: {
                                      permission: "ENABLE",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id ===
                                "userManagementViewUsersBranchLevel"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  userManagement: {
                                    ...userPermissionUpdate?.userManagement,
                                    view: {
                                      permission: "BRANCH_LEVEL",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id ===
                                "userManagementViewUsersChildCompany"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  userManagement: {
                                    ...userPermissionUpdate?.userManagement,
                                    view: {
                                      permission: "CHILD_COMPANY",
                                    },
                                  },
                                });
                              }
                            }}
                          />
                        </div>
                        <div className="flex items-center">
                          <FontAwesomeIcon
                            icon={faArrowTurnUp}
                            className="rotate-90"
                          />
                          <PermissionInput
                            permissionName="Edit"
                            diasableId="userManagementEditDisable"
                            enableId="userManagementEditEnable"
                            branchLevelId="userManagementEditBranchLevel"
                            childCompanyId="userManagementEditChildCompany"
                            isReadOnly={false}
                            isRestrict={true}
                            name="userManagementEdit"
                            permission={
                              userPermissionUpdate?.userManagement?.edit
                                ? userPermissionUpdate?.userManagement?.edit
                                    ?.permission
                                : eachUserDetails?.permission?.userManagement
                                    ?.edit?.permission
                            }
                            onClick={(e) => {
                              if (e.target.id === "userManagementEditDisable") {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  userManagement: {
                                    ...userPermissionUpdate?.userManagement,
                                    edit: {
                                      permission: "DISABLE",
                                    },
                                  },
                                });
                              }
                              if (e.target.id === "userManagementEditEnable") {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  userManagement: {
                                    ...userPermissionUpdate?.userManagement,
                                    edit: {
                                      permission: "ENABLE",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id === "userManagementEditBranchLevel"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  userManagement: {
                                    ...userPermissionUpdate?.userManagement,
                                    edit: {
                                      permission: "BRANCH_LEVEL",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id === "userManagementEditChildCompany"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  userManagement: {
                                    ...userPermissionUpdate?.userManagement,
                                    edit: {
                                      permission: "CHILD_COMPANY",
                                    },
                                  },
                                });
                              }
                            }}
                          />
                        </div>
                        <div className="flex items-center">
                          <FontAwesomeIcon
                            icon={faArrowTurnUp}
                            className="rotate-90"
                          />
                          <PermissionInput
                            permissionName="Add Users"
                            diasableId="userManagementAddUsersDisable"
                            enableId="userManagementAddUsersEnable"
                            name="userManagementAddUsers"
                            permission={
                              userPermissionUpdate?.userManagement?.addUsers
                                ? userPermissionUpdate?.userManagement?.addUsers
                                    ?.permission
                                : eachUserDetails?.permission?.userManagement
                                    ?.addUsers?.permission
                            }
                            onClick={(e) => {
                              if (
                                e.target.id === "userManagementAddUsersDisable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  userManagement: {
                                    ...userPermissionUpdate?.userManagement,
                                    addUsers: {
                                      permission: "DISABLE",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id === "userManagementAddUsersEnable"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  userManagement: {
                                    ...userPermissionUpdate?.userManagement,
                                    addUsers: {
                                      permission: "ENABLE",
                                    },
                                  },
                                });
                              }
                              if (
                                e.target.id === "userManagementAddUsersRead"
                              ) {
                                setUserPermissionUpdate({
                                  ...userPermissionUpdate,
                                  userManagement: {
                                    ...userPermissionUpdate?.userManagement,
                                    addUsers: {
                                      permission: "READ_ONLY",
                                    },
                                  },
                                });
                              }
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  <div>
                    <div className="flex items-center">
                      <div className="w-5"></div>
                      <PermissionInput
                        permissionName="Vehicle types"
                        diasableId="vehicleTypesDisable"
                        enableId="vehicleTypesEnable"
                        readId="vehicleTypesRead"
                        isReadOnly={true}
                        name="vehicleTypes"
                        permission={
                          userPermissionUpdate?.vehicleTypes
                            ? userPermissionUpdate?.vehicleTypes?.permission
                            : eachUserDetails?.permission?.vehicleTypes
                                ?.permission
                        }
                        onClick={(e) => {
                          if (e.target.id === "vehicleTypesDisable") {
                            setUserPermissionUpdate({
                              ...userPermissionUpdate,
                              vehicleTypes: {
                                permission: "DISABLE",
                              },
                            });
                          }
                          if (e.target.id === "vehicleTypesEnable") {
                            setUserPermissionUpdate({
                              ...userPermissionUpdate,
                              vehicleTypes: {
                                permission: "ENABLE",
                              },
                            });
                          }
                          if (e.target.id === "vehicleTypesRead") {
                            setUserPermissionUpdate({
                              ...userPermissionUpdate,
                              vehicleTypes: {
                                permission: "READ_ONLY",
                              },
                            });
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    <div className="flex items-center">
                      <div className="w-5"></div>
                      <PermissionInput
                        permissionName="Image Uploader"
                        diasableId="imageUploaderDisable"
                        enableId="imageUploaderEnable"
                        readId="imageUploaderRead"
                        isReadOnly={true}
                        name="imageUploader"
                        permission={
                          userPermissionUpdate?.imageUploader
                            ? userPermissionUpdate?.imageUploader?.permission
                            : eachUserDetails?.permission?.imageUploader
                                ?.permission
                        }
                        onClick={(e) => {
                          if (e.target.id === "imageUploaderDisable") {
                            setUserPermissionUpdate({
                              ...userPermissionUpdate,
                              imageUploader: {
                                permission: "DISABLE",
                              },
                            });
                          }
                          if (e.target.id === "imageUploaderEnable") {
                            setUserPermissionUpdate({
                              ...userPermissionUpdate,
                              imageUploader: {
                                permission: "ENABLE",
                              },
                            });
                          }
                          if (e.target.id === "imageUploaderRead") {
                            setUserPermissionUpdate({
                              ...userPermissionUpdate,
                              imageUploader: {
                                permission: "READ_ONLY",
                              },
                            });
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    <div className="flex items-center">
                      <div className="w-5"></div>
                      <PermissionInput
                        permissionName="Api Docs"
                        diasableId="apiDocsDisable"
                        enableId="apiDocsEnable"
                        readId="apiDocsRead"
                        isReadOnly={true}
                        name="apiDocs"
                        permission={
                          userPermissionUpdate?.apiDocs
                            ? userPermissionUpdate?.apiDocs?.permission
                            : eachUserDetails?.permission?.apiDocs?.permission
                        }
                        onClick={(e) => {
                          if (e.target.id === "apiDocsDisable") {
                            setUserPermissionUpdate({
                              ...userPermissionUpdate,
                              apiDocs: {
                                permission: "DISABLE",
                              },
                            });
                          }
                          if (e.target.id === "apiDocsEnable") {
                            setUserPermissionUpdate({
                              ...userPermissionUpdate,
                              apiDocs: {
                                permission: "ENABLE",
                              },
                            });
                          }
                          if (e.target.id === "apiDocsRead") {
                            setUserPermissionUpdate({
                              ...userPermissionUpdate,
                              apiDocs: {
                                permission: "READ_ONLY",
                              },
                            });
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
            {isEvent && (
              <>
                <div className="relative flex-auto p-6 space-y-3">
                  {isEditEvent ? (
                    <div>
                      <div className="text-lg text-primary">
                        Region / City name
                      </div>
                      <div className="text-xl font-semibold ">
                        {eventRegionName}
                      </div>
                    </div>
                  ) : (
                    <div className="flex space-x-3">
                      <div className="space-y-3 grow">
                        <div>Select Region / City name</div>
                        <Select
                          options={options}
                          onChange={(e) => {
                            dispatch(
                              setRegion({
                                region: e.value + " region",
                              })
                            );
                          }}
                        />
                        <div className="flex items-center space-x-3">
                          <input
                            type="checkbox"
                            id="globalRegion"
                            onChange={() => {
                              dispatch(
                                setRegion({
                                  region: "global global",
                                })
                              );
                            }}
                          />
                          <label
                            htmlFor="globalRegion"
                            className="cursor-pointer select-none"
                          >
                            All region
                          </label>
                        </div>
                      </div>
                      <div className="space-y-3 grow">
                        <div>Select FlatRegion / City name</div>
                        <Select
                          options={flatRegions}
                          onChange={(e) => {
                            console.log(e.value + " flatregion");
                            dispatch(
                              setRegion({
                                region: `${e.value} flatregion`,
                              })
                            );
                          }}
                        />
                        <div className="flex items-center space-x-3">
                          <input
                            type="checkbox"
                            id="globalflatRegion"
                            onChange={() => {
                              dispatch(
                                setRegion({
                                  region: "flatregionglobal flatregionglobal",
                                })
                              );
                            }}
                          />
                          <label
                            htmlFor="globalflatRegion"
                            className="cursor-pointer select-none"
                          >
                            All flatregion
                          </label>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="">
                    {isEditEvent ? (
                      <ModalInputField
                        labelName="Event Name"
                        type="text"
                        placeholder="Enter Event Name"
                        fontawesomeIcon={faCalendarDay}
                        onChange={eventNameInput}
                        inputvalue={eventNameValue}
                      />
                    ) : (
                      <ModalInputField
                        labelName="Event Name"
                        type="text"
                        placeholder="Enter Event Name"
                        fontawesomeIcon={faCalendarDay}
                        onChange={eventNameInput}
                      />
                    )}
                  </div>

                  <div className="sm:flex py-2 sm:space-x-10">
                    <div className="w-full grow ">
                      {isEditEvent ? (
                        <ModalInputField
                          labelName={`Start Date (${startDateValue})`}
                          type="date"
                          placeholder="Enter Start Name"
                          fontawesomeIcon={faCalendar}
                          onChange={startDateInput}
                        />
                      ) : (
                        <ModalInputField
                          labelName="Start Date"
                          type="date"
                          placeholder="Enter Start Name"
                          fontawesomeIcon={faCalendar}
                          onChange={startDateInput}
                        />
                      )}
                    </div>
                    <div className="w-full grow sm:mt-0 mt-5">
                      {isEditEvent ? (
                        <ModalInputField
                          labelName={`End Date (${endDateValue})`}
                          type="date"
                          placeholder="Enter End Date"
                          fontawesomeIcon={faCalendar}
                          onChange={endDateInput}
                        />
                      ) : (
                        <ModalInputField
                          labelName="End Date"
                          type="date"
                          placeholder="Enter End Date"
                          fontawesomeIcon={faCalendar}
                          onChange={endDateInput}
                        />
                      )}
                    </div>
                  </div>
                  <div>
                    {isEditEvent ? (
                      <ModalInputField
                        labelName="Markup"
                        type="text"
                        placeholder="Enter Mark up"
                        fontawesomeIcon={faDollar}
                        onChange={markupInput}
                        inputvalue={markupValue}
                      />
                    ) : (
                      <ModalInputField
                        labelName="Markup"
                        type="text"
                        placeholder="Enter Mark up"
                        fontawesomeIcon={faDollar}
                        onChange={markupInput}
                      />
                    )}
                  </div>
                </div>
              </>
            )}
            {isAffiliate && (
              <div className="relative flex-auto px-6 py-3 space-y-3">
                <div className="text-red-600 font-semibold text-xs pb-3">
                  *Fields are mandatory
                </div>
                <div className="sm:flex space-x-0 sm:space-x-10">
                  <div className="w-full grow ">
                    <ModalInputField
                      labelName="Affiliate Name*"
                      type="text"
                      placeholder="Enter Affiliate Name"
                      fontawesomeIcon={faUser}
                      onChange={affiliateNameInput}
                    />
                  </div>
                  <div className="w-full grow pt-5 sm:pt-0">
                    <ModalInputField
                      labelName="Contact Person*"
                      type="text"
                      fontawesomeIcon={faUser}
                      placeholder="Enter Contact Name"
                      onChange={contactNameInput}
                    />
                  </div>
                </div>
                <div className="sm:flex space-x-0 sm:space-x-10">
                  <div className="w-full grow pt-5 sm:pt-0">
                    <ModalInputField
                      labelName="Affiliate Id*"
                      type="text"
                      fontawesomeIcon={faIdCard}
                      placeholder="Enter Company Id"
                      onChange={companyaffiliateIdNameInput}
                    />
                  </div>
                  <div className="w-full grow pt-5 sm:pt-0">
                    <ModalInputField
                      labelName="Company Password*"
                      type="text"
                      fontawesomeIcon={faKey}
                      placeholder="Enter Company Name"
                      onChange={companyaffiliatePasswordInput}
                    />
                  </div>
                </div>

                <div className="sm:flex py-2 space-x-0 sm:space-x-10">
                  <div className="w-full grow ">
                    <ModalInputField
                      labelName="Email 1 (username)*"
                      type="email"
                      fontawesomeIcon={faEnvelope}
                      placeholder="Enter Email"
                      onChange={email1Input}
                    />
                  </div>
                  <div className="w-full grow pt-5 sm:pt-0">
                    <ModalInputField
                      labelName="Email 2*"
                      type="email"
                      fontawesomeIcon={faEnvelope}
                      placeholder="Enter Email"
                      onChange={email2Input}
                    />
                  </div>
                </div>
                <div>
                  <ModalInputField
                    labelName="Address*"
                    type="textarea"
                    fontawesomeIcon={faLocationDot}
                    placeholder="Enter Address"
                    onChange={addressInput}
                  />
                </div>
                <div className="sm:flex space-x-0 sm:space-x-10">
                  <div className="w-full grow ">
                    <ModalInputField
                      labelName="Mobile Number 1*"
                      type="number"
                      fontawesomeIcon={faPhone}
                      placeholder="Enter mobile number"
                      onChange={mobile1NumberInput}
                    />
                  </div>
                  <div className="w-full grow pt-5 sm:pt-0">
                    <ModalInputField
                      labelName="Mobile Number 2"
                      type="number"
                      fontawesomeIcon={faPhone}
                      placeholder="Enter mobile number"
                      onChange={mobile2NumberInput}
                    />
                  </div>
                  <div className="w-full grow pt-5 sm:pt-0">
                    <ModalInputField
                      labelName="Mobile Number 3"
                      type="number"
                      fontawesomeIcon={faPhone}
                      placeholder="Enter mobile number"
                      onChange={mobile3NumberInput}
                    />
                  </div>
                </div>
                <div className="sm:flex py-2 space-x-0 sm:space-x-8">
                  <div className="relative">
                    <div className="absolute top-[21rem] ">
                      {openContryCode && (
                        <div className="absolute mx-1 overflow-y-auto bg-white border shadow-2xl -translate-y-9 h-60 scrollbar rounded-bl-md rounded-br-md bottom-2">
                          {CountryList.map(
                            (country) =>
                              country.name
                                .toLowerCase()
                                .includes(searchCountry.toLowerCase()) && (
                                <div
                                  onClick={(e) => {
                                    dispatch(
                                      setCountryInput({
                                        countryInput: country?.name,
                                      })
                                    );
                                    dispatch(
                                      setCountryCode({
                                        countryCode: country?.dial_code,
                                      })
                                    );
                                    setCountry(country?.name);
                                    setopenContryCode(false);
                                  }}
                                  className="flex items-center justify-between px-3 space-y-2 text-sm cursor-pointer hover:bg-primary hover:text-white"
                                >
                                  <div>{country.name}</div>
                                  <div>{country.dial_code}</div>
                                </div>
                              )
                          )}
                        </div>
                      )}
                    </div>
                    <div>
                      <ModalInputField
                        labelName="Country*"
                        type="text"
                        fontawesomeIcon={faEarthAmericas}
                        placeholder="Enter Country"
                        inputvalue={country}
                        onClick={() => {
                          setopenContryCode(true);
                        }}
                        onChange={(e) => {
                          setSearchCountry(e.target.value);
                        }}
                        onFocus={() => {
                          setopenContryCode(true);
                          dispatch(
                            setCountryInput({
                              countryInput: "",
                            })
                          );
                        }}
                      />
                    </div>
                  </div>

                  <div>
                    <ModalInputField
                      labelName="City*"
                      type="text"
                      fontawesomeIcon={faCity}
                      placeholder="Enter City"
                      inputvalue={affiliateCity}
                      onChange={setAffiliateCity}
                    />
                  </div>

                  <div className="pt-5 sm:pt-0">
                    <div className="flex items-center space-x-1 text-primary pb-2">
                      <FontAwesomeIcon icon={faUser} />
                      <div className="text-primary">Status*</div>
                    </div>

                    <Select
                      options={[
                        { value: "NONE", label: "None" },
                        { value: "ACTIVE", label: "Active" },
                        { value: "INACTIVE", label: "Inactive" },
                      ]}
                      onChange={(e) => {
                        dispatch(setStatus({ status: e.value }));
                      }}
                    />
                    {/* <select
                      className="h-10 border border-gray-300 rounded-md w-full sm:w-60 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                      onClick={(e) => {
                        
                        dispatch(setStatus({ status: e.target.value }));
                      }}
                    >
                      <option
                        value="NONE"
                        onClick={(e) => {
                          
                        }}
                      >
                        None
                      </option>
                      <option value="ACTIVE">Active</option>
                      <option value="INACTIVE"> Inactive</option>
                    </select> */}
                  </div>
                  {/*<div className="grow w-72 pt-5 sm:pt-0">
                     <div className="">
                      <div className="flex items-center space-x-2 pb-2">
                        <FontAwesomeIcon
                          icon={faMapLocationDot}
                          className="w-5 text-primary"
                        />
                        <div>Select Region</div>
                      </div>
                      <Select
                        options={options}
                        isMulti
                        onChange={afiliateRegionsAdd}
                      />
                      <div className="flex space-x-1 pt-3">
                        <div className="text-sm">Global</div>
                        <input
                          type="checkbox"
                          className="w-5 h-5"
                          onClick={affliateGlobalCheck}
                        />
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            )}
            {isVehicleAdd && (
              <div className="sm:flex">
                <div className="md:w-1/4 lg:w-1/3 mx-auto sm:mx-5 my-3 sm:my-12">
                  {vehicleImage?.name ? (
                    <img
                      className="w-auto max-h-32"
                      src={
                        vehicleImage?.name && URL.createObjectURL(vehicleImage)
                      }
                      alt="car"
                    />
                  ) : (
                    <FontAwesomeIcon
                      icon={faCar}
                      className="text-5xl text-gray-600 ml-[45%]"
                    />
                  )}
                  <div className="mt-4 text-sm text-gray-600 text-center">
                    <div className="mb-2 font-semibold text-black">
                      Upload Car Images
                    </div>
                    <div className="text-center ml-[15%] lg:ml-[5%] xl:ml-[10%]">
                      <input type="file" onChange={vehicleImageInput} />
                    </div>
                  </div>
                </div>
                <div className="lg:w-2/4 relative flex-auto p-5 space-y-3">
                  <div className="flex space-x-1 items-center">
                    <div className="text-gray-500 text-sm">Category :</div>
                    <div className="text-teal-600 font-semibold">
                      {categoryType}
                    </div>
                  </div>
                  <div>
                    <ModalInputField
                      labelName="Vehicle Name"
                      type="text"
                      placeholder="Enter Vehicle Name"
                      fontawesomeIcon={faCar}
                      onChange={vehicleTypeInput}
                      inputvalue={vehicleTypeValue}
                    />
                  </div>
                  <div className="md:flex xl:flex-row py-2 space-x-0 space-y-5 sm:space-y-0 md:space-x-6 2xl:space-x-10">
                    <div className="w-full grow ">
                      <ModalInputField
                        labelName="Number of Passengers"
                        type="text"
                        placeholder="Enter Passenger Number"
                        fontawesomeIcon={faUser}
                        onChange={noOfPassenger}
                        inputvalue={noOfPassengerValue}
                      />
                    </div>
                    <div className="w-full grow sm:pt-5 md:pt-0 xl:pt-0">
                      <ModalInputField
                        labelName="Number of Luggages"
                        type="text"
                        placeholder="Enter Number of Luggages"
                        fontawesomeIcon={faUser}
                        onChange={noOfLuggage}
                        inputvalue={noOfLuggageValue}
                      />
                    </div>
                  </div>
                  <div>
                    <ModalInputField
                      labelName="Vehicle Description"
                      type="textarea"
                      fontawesomeIcon={faLocationDot}
                      placeholder="Enter vehicle description"
                      onChange={vehicleDescription}
                      inputvaluetextArea={vehicleDescriptionValue}
                    />
                  </div>
                  <div>
                    <div>Vehicle Status</div>
                    <select
                      name=""
                      id=""
                      value={vehicleStatusValue}
                      onChange={vehicleStatusChange}
                    >
                      <option value="ACTIVE">Active</option>
                      <option value="INACTIVE">Inactive</option>
                    </select>
                  </div>
                </div>
              </div>
            )}
            {isVehicleEdit && (
              <div className="sm:flex sm:overflow-y-auto">
                <div className="lg:w-1/3 mx-auto sm:mx-3 my-12">
                  <div className="flex items-center space-x-2 justify-end cursor-pointer">
                    {newCategoryAdd && (
                      <div className="w-80 h-full top-0 animate__animated animate__fadeInLeft absolute bg-gray-100 rounded-tl-xl rounded-bl-xl">
                        <div className="mx-5 my-12">
                          <div className="mb-2 font-semibold text-black">
                            Add New Category
                          </div>
                          {vehicleCategoryImage ? (
                            <img
                              className="w-auto max-h-32"
                              src={URL.createObjectURL(vehicleCategoryImage)}
                              alt="car"
                            />
                          ) : (
                            <div className="mx-auto flex justify-center">
                              <FontAwesomeIcon
                                icon={faCar}
                                className="h-20 w-20 text-gray-300 ml-[5%]"
                              />
                            </div>
                          )}
                          <div className="mt-4 text-sm text-gray-600">
                            <div className="text-left">
                              <input
                                type="file"
                                onChange={(e) => {
                                  setvehicleCategoryImageInput(
                                    e.target.files[0]
                                  );
                                }}
                              />
                            </div>
                            <div className="py-3 ">
                              <div className="text-sm font-semibold">
                                Category Name
                              </div>
                              <div className="border-b border-gray-500">
                                <input
                                  type="text"
                                  placeholder="Enter Category name"
                                  className=""
                                  onChange={(e) => {
                                    setVehicleCategoryNameInput(e.target.value);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="flex justify-end items-center space-x-5 ">
                            <div
                              onClick={() => {
                                setNewCategoryAdd(false);
                              }}
                              className=""
                            >
                              Cancel
                            </div>
                            <div
                              onClick={() => {
                                dispatch({
                                  type: "ADD_VEHICLE_CATEGORY",
                                  payload: {
                                    vehicleId: vehicleId,
                                    body: formDataVehicleCategory,
                                    token,
                                  },
                                });
                                setNewCategoryAdd(false);
                              }}
                              className="text-white bg-secondary px-2 py-0.5 rounded-sm"
                            >
                              Add
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="sm:h-96">
                    <div className="mx-5 my-12">
                      <img
                        className="w-auto max-h-32 mx-auto"
                        src={
                          vehicleImage.name
                            ? URL.createObjectURL(vehicleImage)
                            : vehicleImage
                        }
                        alt="car"
                      />
                      <div className="mt-4 text-sm text-gray-600 text-center">
                        <div className="mb-2 font-semibold text-black">
                          Upload Car Image
                        </div>
                        <div className="text-center ml-[15%] lg:ml-[5%] xl:ml-[10%]">
                          <input type="file" onChange={vehicleImageInput} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="lg:w-2/4 relative flex-auto p-5 space-y-3">
                  <div>
                    <ModalInputField
                      labelName="Vehicle Type"
                      type="text"
                      placeholder="Enter Vehicle Type"
                      fontawesomeIcon={faCar}
                      onChange={vehicleTypeInput}
                      inputvalue={vehicleTypeValue}
                    />
                  </div>
                  <div className="md:flex lg:flex-col xl:flex-row py-2 space-x-0 lg:space-x-0 space-y-5 sm:space-y-0 md:space-x-10 xl:space-x-10">
                    <div className="w-full grow ">
                      <ModalInputField
                        labelName="Number of Passengers"
                        type="text"
                        placeholder="Enter Passenger Number"
                        fontawesomeIcon={faUser}
                        onChange={noOfPassenger}
                        inputvalue={noOfPassengerValue}
                      />
                    </div>
                    <div className="w-full grow sm:pt-5 lg:pt-5 md:pt-0 xl:pt-0">
                      <ModalInputField
                        labelName="Number of Luggages"
                        type="text"
                        placeholder="Enter Number of Luggages"
                        fontawesomeIcon={faUser}
                        onChange={noOfLuggage}
                        inputvalue={noOfLuggageValue}
                      />
                    </div>
                  </div>
                  <div className="space-x-10">
                    <ModalInputField
                      labelName="Vehicle Description"
                      type="textarea"
                      fontawesomeIcon={faLocationDot}
                      placeholder="Enter vehicle description"
                      onChange={vehicleDescription}
                      inputvaluetextArea={vehicleDescriptionValue}
                    />
                  </div>
                  <div>
                    <div className="">Vehicle Status</div>
                    <select
                      name=""
                      id=""
                      value={vehicleStatusValue}
                      onChange={vehicleStatusChange}
                    >
                      <option value="ACTIVE">Active</option>
                      <option value="INACTIVE">Inactive</option>
                    </select>
                  </div>
                </div>
              </div>
            )}
            {isSinglebooingDetailCanecl && (
              <>
                <div className="relative flex-auto p-6 space-y-3">
                  <div>
                    <div>Cancellation policies</div>
                    <div>
                      <div className="sm:flex space-x-4 sm:space-x-2">
                        <div>1. Free cancellation until</div>
                        <div className="font-semibold">
                          {moment(travelDate)
                            .subtract(1, "days")
                            .format("dddd(DD), MMMM YYYY")}{" "}
                          at <span className="font-normal">{travelTime}</span>
                        </div>
                        {/* <div>{travelTime}</div> */}
                      </div>
                      <div className="sm:flex space-x-4 sm:space-x-2">
                        <div>2. Any cancellation on or after</div>
                        <div className="font-semibold">
                          {moment(travelDate)
                            .subtract(1, "days")
                            .format("dddd(DD), MMMM YYYY")}{" "}
                          at <span className="font-normal">{travelTime}</span>
                          <span className="font-normal">
                            {" "}
                            is non-refundable
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="flex py-6 space-x-1 space-y-1 text-left ">
                    <div className="flex items-center w-64 space-x-2 mt-2">
                      <FontAwesomeIcon
                        icon={faCoins}
                        className="w-4 h-4 text-primary"
                      />
                      <div className="text-base font-semibold">
                        Cancellation Charges
                      </div>
                    </div>
                    <div className="w-32">
                      {user?.role === "ADMIN" ? (
                        <input
                          type="text"
                          placeholder="Enter Cancellation fee"
                          className="text-xl font-medium border-b-2 focus:outline-none grow text-primary textField w-32"
                          onChange={cancelFeeInput}
                          value={canelFeeInputValue}
                        />
                      ) : (
                        <div className="text-xl font-medium focus:outline-none grow text-primary ">
                          {canelFeeInputValue}
                        </div>
                      )}
                    </div>
                  </div>

                  <div>
                    <input
                      type="checkbox"
                      id="cancel"
                      name="cancel"
                      value=""
                      onClick={cancelFeeCheckbox}
                    />
                    <label for="cancel">
                      {" "}
                      I agree to the cancellation policy
                    </label>
                    <br />
                  </div>
                </div>
              </>
            )}
            {isSinglebooingDetailPaid && (
              <>
                <div className="relative flex-auto p-6 space-y-3">
                  <div className="flex items-center space-x-10">
                    <div className="text-xl text-primary">Paid by</div>
                    <div className="flex items-baseline space-x-3">
                      <div className="flex space-x-1">
                        <input
                          type="radio"
                          id="payment1"
                          name="pay"
                          value="BANK"
                          className="text-primary"
                          onChange={paymentMethodInput}
                        />
                        <label>BANK</label>
                      </div>
                      <div className="flex space-x-1">
                        <input
                          type="radio"
                          id="payment1"
                          name="pay"
                          value="CARD"
                          onChange={paymentMethodInput}
                        />
                        <label>CARD</label>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="text-xl text-gray-600">Receivable note</div>
                    <textarea
                      ref={paymentNoteRef}
                      className="w-full px-2 py-1 border border-gray-300 rounded-md focus:outline-gray-400"
                    />
                  </div>
                </div>
              </>
            )}
            {isSinglebooingDetailEdit && (
              <>
                <div className="relative flex-auto p-6 space-y-3">
                  {user?.role === "ADMIN" && (
                    <>
                      <div className="font-semibold text-xl border-b-2">
                        Vehicle Details
                      </div>
                      <div className="flex flex-1 space-x-2">
                        <div className="flex  space-x-2">
                          <ModalInputField
                            labelName="Currency"
                            type="text"
                            fontawesomeIcon={faCoins}
                            onChange={currencyInput}
                            inputvalue={currencyUpdate}
                            placeholder=""
                          />
                          <ModalInputField
                            labelName="Price"
                            type="text"
                            fontawesomeIcon={faCoins}
                            onChange={priceUpdateInput}
                            inputvalue={priceUpdate}
                            placeholder="Enter new price"
                          />
                        </div>

                        <PlusIcon className="text-gray-400 w-5" />

                        <ModalInputField
                          labelName="Extra Price"
                          type="text"
                          fontawesomeIcon={faCoins}
                          onChange={extraPriceInput}
                          inputvalue={extraPriceUpdate}
                          placeholder=""
                        />
                        <ModalInputField
                          labelName="Extra Hours"
                          type="text"
                          fontawesomeIcon={faCoins}
                          onChange={extraHourInput}
                          inputvalue={extraHourUpdate}
                          placeholder=""
                        />
                        <div className="text-sm text-gray-500 w-40">
                          Total: USD{" "}
                          {parseInt(priceUpdate) +
                            parseInt(extraPriceUpdate || 0)}
                        </div>
                      </div>
                    </>
                  )}

                  {(user?.role === "ADMIN" ||
                    (user?.role === "USER" &&
                      user?.permission?.manageBooking?.editBooking
                        ?.permission === "ENABLE")) && (
                    <>
                      <div className="font-semibold text-xl border-b-2">
                        Passenger Details
                      </div>
                      <div className="space-y-5">
                        <div className="flex w-full space-x-5 justify-between">
                          <ModalInputField
                            labelName="Pax First Name"
                            type="text"
                            fontawesomeIcon={faUser}
                            onChange={paxUpdateInputfirst}
                            inputvalue={paxtobeUpdateValuefirst}
                            placeholder="Enter  name"
                          />
                          <ModalInputField
                            labelName="Pax Last Name"
                            type="text"
                            fontawesomeIcon={faUser}
                            onChange={paxUpdateInputlast}
                            inputvalue={paxtobeUpdateValuelast}
                            placeholder="Enter  name"
                          />
                        </div>
                        <div className="flex w-full space-x-5  justify-between">
                          <div className="flex space-x-3">
                            <ModalInputField
                              labelName="Country Code"
                              type="text"
                              onClick={countryCodeOnClick}
                              fontawesomeIcon={faContactBook}
                              onChange={codeUpdateInput}
                              inputvalue={codeUpdate}
                              placeholder="Enter new contact number"
                            />

                            {/* <div>
                          <div className="text-gray-600 text-sm font-semibold space-x-1">
                            <FontAwesomeIcon
                              icon={faContactBook}
                              className="w-4 h-4 text-gray-600"
                            />
                            <span>Country code</span>
                          </div>
                          <Select
                            // remove border
                            className="border-none css-13cymwt-control"
                            options={CountryList.map((country) => {
                              return {
                                value: `${country.dial_code} ${country.name}`,
                                label: `${country.dial_code}`,
                              };
                            })}
                            onChange={codeUpdateInput}
                            value={codeUpdate ? codeUpdate : ""}
                          />
                        </div> */}
                            <ModalInputField
                              labelName="Contact Number"
                              type="text"
                              fontawesomeIcon={faContactBook}
                              onChange={contactNumberInput}
                              inputvalue={contactNumberUpdate}
                              placeholder="Enter new contact number"
                            />
                          </div>
                          {user?.role === "ADMIN" && (
                            <>
                              <ModalInputField
                                labelName="Flight Number"
                                type="text"
                                fontawesomeIcon={faPlaneUp}
                                onChange={flightNumberInput}
                                inputvalue={flightNumberUpdate}
                                placeholder="Enter new contact number"
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  {(user?.role === "ADMIN" ||
                    (user?.role === "USER" &&
                      user?.permission?.manageBooking?.editBooking
                        ?.permission === "ENABLE")) && (
                    <>
                      <div className="font-semibold text-xl border-b-2">
                        Booking Details
                      </div>
                      <ModalInputField
                        labelName="Reference Number"
                        type="text"
                        fontawesomeIcon={faNoteSticky}
                        onChange={referenceNumberInput}
                        inputvalue={referenceNumberUpdate}
                        placeholder="Enter new contact number"
                      />
                      <div className="w-full">
                        <div className="text-base font-medium flex items-center relative">
                          <fontawesomeIcon icon={faCalendar} />
                          <div> Travel Date</div>
                        </div>
                        <input
                          type="date"
                          min={user.role === "USER" && formattedToday}
                          value={travelDateUpdate && travelDateUpdate}
                          disabled={!isBookingEditable ? true : false}
                          onChange={(e) => {
                            if (user.role === "USER") {
                              dispatch(
                                setEditBookingError({
                                  editBookingError: "",
                                })
                              );

                              dispatch({
                                type: "DATE_EXIST_WITHIN_EVENT",
                                payload: {
                                  body: {
                                    sourcelat: bookingDetailsById?.source?.lat,
                                    sourcelng: bookingDetailsById?.source?.lng,
                                    destinationlat:
                                      bookingDetailsById?.destination?.lat,
                                    destinationlng:
                                      bookingDetailsById?.destination?.lng,
                                    bookingDate: e.target.value,
                                  },
                                },
                              });
                            }
                            if (user.role === "ADMIN") {
                              travelDateInput(e);
                            }
                          }}
                        />
                        {/* <DatePicker
                      format="dd-MM-y"
                      onChange={travelDateInput}
                      // value={travelDateUpdate}
                    /> */}
                        {editBookingLoading && (
                          <div className="absolute left-48 bottom-[88px]">
                            <Spinner color="red" />
                          </div>
                        )}
                        {editBookingError && (
                          <>
                            <div className="text-red-500 flex items-center space-x-2 absolute right-20 bottom-[90px] ">
                              <FontAwesomeIcon icon={faExclamationCircle} />
                              <div className="font-inter text-sm">
                                {editBookingError}
                              </div>
                              {/* <textarea 
                              className="w-96 h-16"
                              value={editBookingError}
                               /> */}
                            </div>
                          </>
                        )}
                      </div>

                      <ModalInputField
                        labelName="Travel Time"
                        type="time"
                        fontawesomeIcon={faClock}
                        onChange={(e) => {
                          console.log(e);
                          travelTimeUpdateInput(e);
                          dispatch(
                            setEditBookingTime({
                              editBookingTime: e.target.value,
                            })
                          );
                        }}
                        inputvalue={travelTimeUpdate}
                        placeholder="Enter Travel Time"
                        disabled={
                          (user.role === "USER" && !isBookingEditable) ||
                          DateExistsWithinEvent
                            ? true
                            : false
                        }
                      />
                    </>
                  )}

                  {/* <ModalInputField
                    labelName="Travel Date"
                    type="date"
                    fontawesomeIcon={faCalendar}
                    onChange={travelDateInput}
                    inputvalue={travelDateUpdate}
                    placeholder="Enter new price"
                  /> */}
                  {user?.role === "ADMIN" && bookingType === "HOURLY" && (
                    <ModalInputField
                      labelName="Duration for Affiliate (in hours)"
                      type="test"
                      fontawesomeIcon={faClock}
                      onChange={durationForAffiliateInput}
                      inputvalue={durationForAffiliateUpdate}
                      placeholder="Enter Duration for Affiliate"
                    />
                  )}
                </div>
              </>
            )}
            {isSinglebookingAffilate && (
              <>
                <div className="relative flex-auto p-6 space-y-3">
                  <div className="text-primary">
                    <div>Select Affiliate</div>
                    <Select
                      defaultValue={{
                        value: affiliateDetails,
                        label: affiliateDetails?.affiliateName,
                      }}
                      onChange={affiliateSelectOnChange}
                      options={activeAffiliates.map((affiliate) => {
                        return {
                          value: {
                            id: affiliate._id,
                            contact: affiliate.phone1,
                            email1: affiliate?.email1,
                            name: affiliate?.affiliateName,
                          },
                          label: affiliate?.affiliateName,
                        };
                      })}
                    />
                  </div>
                  {affiliateConatct && (
                    <div className="flex space-x-2">
                      <div className="text-primary text-sm ">
                        Affiliate Contact
                      </div>
                      <div>{affiliateConatct}</div>
                    </div>
                  )}
                  <div className="flex space-x-3">
                    <div>
                      <ModalInputField
                        maxLength={3}
                        labelName="Purchase Currency"
                        type="text"
                        inputvalue={affiliatePurchaseCurrencyinput}
                        onChange={affiliatePurchaseCurrencyinputChange}
                      />
                      {!affiliatePurchaseCurrencyinput && (
                        <div className="text-sm text-red-500">
                          Purchase currency is required
                        </div>
                      )}
                    </div>

                    <div className="grow">
                      <div>
                        <ModalInputField
                          labelName="Purchase Price"
                          type="number"
                          inputvalue={affiliatePurchasePriceinput}
                          onChange={affiliatePurchasePriceinputChange}
                        />
                        {!affiliatePurchasePriceinput && (
                          <div className="text-sm text-red-500">
                            Purchase price is required
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <ModalInputField
                    labelName="Affiliate Note"
                    type="textarea"
                    inputvaluetextArea={affiliateNoteinput}
                    onChange={affiliateNoteinputChange}
                  />
                  <div className="flex justify-between space-x-2 items-center">
                    <div
                      onClick={() => {
                        setCreditcard([
                          {
                            // generate id with combination of letters and numbers
                            transactionStoreId: Math.random()
                              .toString(36)
                              .substr(2, 9),
                          },
                          ...creditcard,
                        ]);
                      }}
                      className="cursor-pointer flex space-x-2 items-center hover:bg-teal-600 border border-teal-600 w-40 px-2 py-1 rounded-md text-teal-600 hover:text-white"
                    >
                      {" "}
                      <FontAwesomeIcon icon={faPlus} />
                      <div className="text-sm ">Add Credit Card</div>
                    </div>
                    <CsvDownloader
                      filename="CreditCard"
                      extension=".csv"
                      separator=","
                      columns={[
                        { id: "bookingId", displayName: "Booking Id" },
                        { id: "cardDetails", displayName: "Card Details" },
                        { id: "paymentDate", displayName: "Payment Date" },
                        { id: "currency", displayName: "Currency" },
                        { id: "amount", displayName: "Amount" },
                      ]}
                      datas={creditcard.map((card) => {
                        return {
                          bookingId: bookingDetailsById?.bookingId,
                          cardDetails: card.name + " " + card.cardNumber,
                          paymentDate: moment(card.paymentDate).format(
                            "DD-MM-YYYY"
                          ),
                          currency: card.currency,
                          amount: card.amount,
                        };
                      })}
                      text="Download report"
                    >
                      <div className=" flex  space-x-2 items-center text-sm cursor-pointer hover:bg-teal-600 bg-teal-700 px-4 py-[5px] text-white rounded-md">
                        <div>
                          <FontAwesomeIcon icon={faDownload} />
                        </div>
                        <div
                          onClick={() => {
                            dispatch(setBookingCreditCards(creditcard));
                          }}
                        >
                          Download
                        </div>
                      </div>
                    </CsvDownloader>
                  </div>
                  <div className="sm:h-40 overflow-y-auto scrollbar space-y-3 divide-y-2 divide-emerald-200">
                    {creditcard?.map((card, key) => {
                      let cardDetails =
                        card?.name +
                        " " +
                        card?.bank +
                        " " +
                        card?.cardNumberLastFour;
                      return (
                        <>
                          {!card?.id ? (
                            <div key={key} className="pt-2 space-y-2">
                              <div className="sm:flex items-center sm:space-x-7 md:space-x-7">
                                <div className="">
                                  <div className="text-sm text-gray-500">
                                    Card Number
                                  </div>
                                  <Select
                                    defaultValue={{
                                      value: card,
                                      label:
                                        card?.name +
                                        " " +
                                        card?.bank +
                                        " " +
                                        card?.cardNumberLastFour,
                                    }}
                                    className="w-64 text-sm "
                                    onChange={(e) => {
                                      setCreditcard((prev) => {
                                        let temp = [...prev];
                                        temp[key] = {
                                          ...temp[key],
                                          cardNumberLastFour:
                                            e.value.cardNumberLastFour,
                                          name: e.value.name,
                                          bank: e.value.bank,
                                          _id: e.value._id,
                                        };
                                        return temp;
                                      });
                                      dispatch(
                                        setTransactionRecordStoreStatus({
                                          txnId: card?.transactionStoreId,
                                        })
                                      );
                                    }}
                                    options={allCreditCards.map((card) => {
                                      return {
                                        value: card,
                                        label:
                                          card?.name +
                                          " " +
                                          card?.bank +
                                          " " +
                                          card?.cardNumberLastFour,
                                      };
                                    })}
                                  />
                                </div>
                                <div className="mt-5 sm:mt-0">
                                  <div className="text-sm text-gray-500">
                                    Payment Date
                                  </div>
                                  <input
                                    type="date"
                                    value={card?.paymentDate}
                                    onChange={(e) => {
                                      setCreditcard((prev) => {
                                        let temp = [...prev];
                                        temp[key] = {
                                          ...temp[key],
                                          paymentDate: e.target.value,
                                        };
                                        return temp;
                                      });
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="md:flex lg:flex-col xl:flex-row md:space-x-5 lg:space-x-0 xl:space-x-5 items-center lg:items-start">
                                <div className="flex space-x-5 items-center">
                                  <div className="flex items-center space-x-3 sm:my-3">
                                    <div className="text-sm text-gray-500 mt-2">
                                      Currency
                                    </div>
                                    <input
                                      className="textField w-20 sm:w-36"
                                      type="text"
                                      value={card?.currency}
                                      onChange={(e) => {
                                        setCreditcard((prev) => {
                                          let temp = [...prev];
                                          temp[key] = {
                                            ...temp[key],
                                            currency: e.target.value,
                                          };
                                          return temp;
                                        });
                                      }}
                                    />
                                  </div>
                                  <div className="flex items-center space-x-3">
                                    <div className="text-sm text-gray-500 mt-2">
                                      Amount
                                    </div>
                                    <input
                                      className="textField w-24 sm:w-36"
                                      type="text"
                                      value={card?.amount}
                                      onChange={(e) => {
                                        setCreditcard((prev) => {
                                          let temp = [...prev];
                                          temp[key] = {
                                            ...temp[key],
                                            amount: e.target.value,
                                          };
                                          return temp;
                                        });
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="flex space-x-3 xl:mt-3 mt-4 sm:mt-0">
                                  {transactionRecordStoreStatus[
                                    card?.transactionStoreId
                                  ] ? (
                                    <div>
                                      <FontAwesomeIcon
                                        icon={faCheckCircle}
                                        className="text-green-500"
                                      />
                                    </div>
                                  ) : (
                                    <div
                                      onClick={() => {
                                        dispatch({
                                          type: "ADD_BOOKING_TO_CREDIT_CARD",
                                          payload: {
                                            id: card?._id,
                                            bookingId:
                                              bookingDetailsById?.bookingId,
                                            token: token,
                                            txnId: card?.transactionStoreId,
                                          },
                                        });
                                        dispatch(
                                          setBookingCreditCards(creditcard)
                                        );
                                      }}
                                      className="flex items-center space-x-1 cursor-pointer text-teal-700 font-semibold hover:border-b hover:border-teal-700"
                                    >
                                      <FontAwesomeIcon
                                        icon={faAdd}
                                        className="w-3 "
                                      />
                                      <div className="text-sm">Add</div>
                                    </div>
                                  )}

                                  {!transactionRecordStoreStatus[
                                    card?.transactionStoreId
                                  ] && (
                                    <div className="">
                                      <FontAwesomeIcon
                                        icon={faTrash}
                                        className="cursor-pointer text-red-500"
                                        onClick={() => {
                                          setCreditcard((prev) => {
                                            let temp = [...prev];
                                            temp.splice(key, 1);
                                            return temp;
                                          });
                                        }}
                                      />
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          ) : (
                            <table
                              style={{
                                height: "20px",
                              }}
                            >
                              <tbody>
                                <tr>
                                  <td className="w-30">
                                    <div className="text-sm text-gray-500">
                                      Booking Id
                                    </div>
                                    <div className="flex space-x-2 text-sm ">
                                      {bookingDetailsById?.bookingId}
                                    </div>
                                  </td>
                                  <td className="w-52 truncate">
                                    <div className="text-sm text-gray-500">
                                      Card Details
                                    </div>
                                    <div className="flex space-x-2 text-sm ">
                                      {cardDetails}
                                    </div>
                                  </td>

                                  <td className="text-center ">
                                    <div className="text-sm text-gray-500">
                                      Payment Date
                                    </div>
                                    <div className="text-sm">
                                      {moment(card?.paymentDate).format(
                                        "DD-MM-YYYY"
                                      )}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="text-sm text-gray-500">
                                      Amount
                                    </div>
                                    <div>{card?.amount}</div>
                                  </td>
                                  <td>
                                    <div className="text-sm text-gray-500">
                                      Currency
                                    </div>
                                    <div>{card?.currency}</div>
                                  </td>
                                  {/* add delete */}
                                  <td>
                                    <div
                                      onClick={() => {
                                        setopenCardDeleteModal(true);
                                        let c = [card?.id];
                                        console.log(c);
                                        setcardsToBeDeleted(c);
                                      }}
                                    >
                                      <FontAwesomeIcon
                                        icon={faTrash}
                                        className="cursor-pointer text-red-500"
                                      />
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          )}

                          {openCardDeleteModal && (
                            <div>
                              <div>Are you sure you want to delete ?</div>
                              <div className="space-x-4">
                                <button
                                  onClick={() => {
                                    dispatch({
                                      type: "DELETE_CREDIT_CARDS_FROM_BOOKING",
                                      payload: {
                                        body: {
                                          creditCards: cardsToBeDeleted,
                                        },
                                        bookingId:
                                          bookingDetailsById?.bookingId,
                                        token: token,
                                      },
                                    });
                                    setopenCardDeleteModal(false);
                                  }}
                                >
                                  Yes
                                </button>
                                <button
                                  onClick={() => {
                                    setopenCardDeleteModal(false);
                                  }}
                                >
                                  No
                                </button>
                              </div>
                            </div>
                          )}
                        </>
                      );
                    })}
                  </div>
                </div>
              </>
            )}
            {isSingleBookingDriver && (
              <>
                <div className="relative flex-auto p-6 space-y-3">
                  <ModalInputField
                    labelName="Driver Name"
                    type="text"
                    onChange={driverNameInput}
                    inputvalue={driverName}
                    placeholder="Enter Driver Name"
                  />
                  <div className="py-2">
                    <ModalInputField
                      labelName="Driver Contact"
                      type="text"
                      onChange={driverContactInput}
                      inputvalue={driverContact}
                      placeholder="Enter Driver Contact"
                    />
                  </div>
                </div>
              </>
            )}
            {isSingleBookingUploadInvoice && (
              <>
                <div className="relative flex-auto p-6 space-y-3">
                  <div className="text-xl text-primary">Invoice No</div>
                  <input
                    type="text"
                    onChange={invoiceInputChnage}
                    className="textField w-full"
                  />
                </div>
              </>
            )}
            {isSinglebooingDetailDocuments && (
              <>
                <div className="relative flex-auto p-6 space-y-3">
                  <div className="sm:flex items-center justify-between sm:space-x-10">
                    <div>Choose document type:</div>
                    <div className="flex space-x-5 ">
                      <div className="flex space-x-2 items-center">
                        <input
                          type="radio"
                          id="invoice"
                          name="Document"
                          value="INVOICE"
                          onChange={documentInvoiceChange}
                        />
                        <label
                          for="invoice"
                          className="cursor-pointer text-lg font-semibold text-primary"
                        >
                          {" "}
                          Invoice
                        </label>
                        <Tooltip title="View Invoice">
                          <a
                            target="_blank"
                            href={`/manageBooking/${bookingDetailsById?.bookingId}/view/invoice`}
                            rel="noreferrer"
                          >
                            <button>
                              <FontAwesomeIcon icon={faEye} />
                            </button>
                          </a>
                        </Tooltip>
                      </div>
                      <div className="flex space-x-2">
                        <input
                          name="Document"
                          id="voucher"
                          type="radio"
                          value="VOUCHER"
                          onChange={documentVoucherChange}
                        />
                        <label
                          for="voucher"
                          className="cursor-pointer
                           text-lg font-semibold text-primary"
                        >
                          {" "}
                          Voucher
                        </label>
                        <Tooltip title="View Voucher">
                          <a
                            target="_blank"
                            href={`/manageBooking/${bookingDetailsById?.bookingId}/view/voucher`}
                            rel="noreferrer"
                          >
                            <button>
                              <FontAwesomeIcon icon={faEye} />
                            </button>
                          </a>
                        </Tooltip>
                      </div>
                      <div className="flex space-x-2">
                        <input
                          id="driver"
                          name="Document"
                          type="radio"
                          value="DRIVER"
                          onChange={documentDriverChange}
                        />
                        <label
                          for="driver"
                          className="cursor-pointer text-lg font-semibold text-primary"
                        >
                          Driver
                        </label>
                      </div>
                    </div>
                    {/* <div className="text-sm text-left sm:text-center text-green-800 cursor-pointer hover:text-green-600"></div> */}
                  </div>

                  <div className="flex space-x-2">
                    <div>Send Email To:</div>
                    <input
                      className="w-1/2 textField"
                      type="text"
                      value={singleBookingEmailInputValue}
                      onChange={singlebookEmailChangeInput}
                    />
                  </div>
                </div>
              </>
            )}
            {isPriceEditBookingSummary && (
              <>
                <div className="relative flex-auto p-6 space-y-3">
                  <ModalInputField
                    labelName="Price"
                    type="text"
                    fontawesomeIcon={faCoins}
                    onChange={priceUpdateInput}
                    inputvalue={priceUpdate}
                    placeholder="Enter new price"
                  />
                </div>
              </>
            )}
            {isEditCompany && (
              <>
                <div className="relative flex-auto p-6 space-y-3">
                  <div className="w-full">
                    <FontAwesomeIcon
                      icon={faBuilding}
                      className="w-12 h-12 text-center text-gray-500"
                    />
                    <div>
                      <input
                        type="file"
                        accept="image/jpeg, image/png, image/jpg"
                        onChange={companyLogoInput}
                      />
                    </div>
                  </div>

                  <div className="sm:flex pt-6 sm:space-x-10">
                    <div className="w-full text-gray-700">
                      <ModalInputField
                        labelName="Company Name *"
                        type="text"
                        placeholder="Enter Company Name"
                        fontawesomeIcon={faBuilding}
                        onChange={companyNameInput}
                        inputvalue={companyNameValue}
                      />
                    </div>
                    <div className="w-full text-gray-700">
                      <ModalInputField
                        labelName="Company Address *"
                        type="text"
                        placeholder="Enter Company Name"
                        fontawesomeIcon={faBuilding}
                        onChange={companyEditAddressInput}
                        inputvalue={companyEditAddressValue}
                      />
                    </div>
                    <div className="w-full text-gray-700 grow mt-5 sm:mt-0">
                      <ModalInputField
                        labelName=" Email Address *"
                        type="email"
                        placeholder="Enter company email address"
                        fontawesomeIcon={faEnvelope}
                        onChange={companyEmailInput}
                        inputvalue={companyEmailValue}
                      />
                    </div>
                  </div>

                  <div className="sm:flex py-2 sm:space-x-10">
                    <div className="w-full text-gray-700 grow">
                      <ModalInputField
                        labelName="Website (optional)"
                        type="text"
                        placeholder="Enter website"
                        fontawesomeIcon={faGlobe}
                        onChange={companyWebsiteInput}
                        inputvalue={companyWebsiteValue}
                      />
                    </div>
                    <div className="w-full text-gray-700 grow mt-5 sm:mt-0">
                      <ModalInputField
                        labelName="GST / VAT (optional)"
                        type="text"
                        placeholder="Enter GST / VAT"
                        fontawesomeIcon={faEnvelope}
                        onChange={companyGstInput}
                        inputvalue={companyGstValue}
                      />
                    </div>
                  </div>

                  <div className="sm:flex sm:space-x-10">
                    <div className="text-gray-700 grow">
                      <ModalInputField
                        labelName="Credit limit"
                        type="text"
                        placeholder="Enter Credit limit"
                        fontawesomeIcon={faEnvelope}
                        onChange={companyCreditLimitInput}
                        inputvalue={companyCreditLimitValue}
                      />
                    </div>
                    <div className="text-gray-700 grow mt-5 sm:mt-0">
                      <ModalInputField
                        labelName="Discount"
                        type="text"
                        placeholder="Enter Discount"
                        fontawesomeIcon={faEnvelope}
                        onChange={companyDiscountInput}
                        inputvalue={companyDiscountValue}
                      />
                    </div>
                    <div className="text-gray-700 grow mt-5 sm:mt-0">
                      <ModalInputField
                        labelName="Markup"
                        type="text"
                        placeholder="Enter Markup"
                        fontawesomeIcon={faEnvelope}
                        onChange={companyMarkupInput}
                        inputvalue={companyMarkupValue}
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
            {isAddCard && (
              <>
                <div className="relative flex-auto p-6 space-y-3">
                  <div className="sm:flex sm:space-x-10 space-y-5 sm:space-y-0">
                    <div className="w-full text-gray-700">
                      <ModalInputField
                        labelName="Card Number *"
                        type="text"
                        placeholder="Enter Card Number"
                        fontawesomeIcon={faCreditCard}
                        onChange={cardNumberInput}
                        maxLength="4"
                      />
                      <div className="text-xs text-red-700">
                        Add last 4 digit of card
                      </div>
                    </div>
                    <div className="w-full text-gray-700">
                      <ModalInputField
                        labelName="Card Holder Name *"
                        type="text"
                        placeholder="Enter Card Holder Name"
                        fontawesomeIcon={faUser}
                        onChange={cardHolderNameInput}
                      />
                    </div>
                  </div>
                  <div className="w-full text-gray-700">
                    <ModalInputField
                      labelName="Bank Name *"
                      type="text"
                      placeholder="Enter Bank Name"
                      fontawesomeIcon={faBank}
                      onChange={cardBankNameInput}
                    />
                  </div>
                </div>
              </>
            )}
            {isDeleteRegion && (
              <>
                <div className="relative flex-auto p-6 space-y-3">
                  <div className="text-md  text-red-700">
                    Are you sure to delete this region ? if yes type{" "}
                    <span className="font-bold text-lg"> delete</span>
                  </div>
                  <input
                    type="text"
                    onChange={(e) => {
                      setmatchdeleteWord(e.target.value);
                    }}
                    placeholder="Type Here "
                    className="textField"
                  />
                </div>
              </>
            )}
            {isLoggedOut && (
              <>
                <div className="p-5">
                  <span className="text-xl">
                    Are you sure you want to Logout?
                  </span>
                </div>
              </>
            )}
            {isQuoteBy && (
              <>
                <div className="flex p-5 items-center space-x-3">
                  <div>Quation By :</div>
                  <div style={{ width: "250px" }}>
                    <Select
                      options={companyDetails?.users?.map((item) => ({
                        value: item,
                        label: item.userName,
                      }))}
                      onChange={(e) => {
                        dispatch(setQuoteBy({ quotedBy: e.value.userName }));
                      }}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
          {/*footer*/}
          <div className="flex items-center justify-end p-3 sm:p-5 border-t border-solid rounded-b border-slate-200">
            <button
              className="px-2 py-2 mb-1 mr-2 text-sm font-medium text-black"
              type="button"
              onClick={cancelOnClick}
            >
              Cancel
            </button>
            {!editBookingAllowed ||
              DateExistsWithinEvent ||
              (!isDeleteRegion && (
                <button
                  className="px-5 sm:px-6 py-1.5 mb-1 mr-1 text-base font-normal text-white bg-[#fb4156] active:bg-[#fb4156] rounded shadow hover:shadow-lg hover:bg-[#fc5669] outline-none focus:outline-none ease-linear transition-all duration-150"
                  type="button"
                  onClick={addOnClick}
                >
                  {addButtonLabel}
                </button>
              ))}
            {isDeleteRegion && matchdeleteWord === "delete" && (
              <button
                className="px-5 sm:px-2 py-1.5 mb-1 mr-1 text-base font-normal text-white bg-[#fb4156] active:bg-[#fb4156] rounded shadow hover:shadow-lg hover:bg-[#fc5669] outline-none focus:outline-none ease-linear transition-all duration-150"
                type="button"
                onClick={addOnClick}
              >
                Yes
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;

export const ModalInputField = ({
  labelName,
  type,
  placeholder,
  onChange,
  fontawesomeIcon,
  inputvalue,
  inputvaluetextArea,
  onClick,
  onBlur,
  onFocus,
  maxLength,
  disabled,
}) => {
  return (
    <div className="grow">
      <div className="space-y-1 text-left">
        <div className="flex items-center space-x-2">
          <FontAwesomeIcon
            icon={fontawesomeIcon}
            className="w-4 h-4 text-gray-600"
          />
          <div className="text-gray-600 text-sm font-semibold">{labelName}</div>
        </div>
        {type === "textarea" ? (
          <textarea
            className="w-full px-3 py-2 text-base text-gray-700 placeholder-gray-400 border rounded-lg focus:outline-none"
            rows="2"
            placeholder={placeholder}
            onChange={onChange}
            value={inputvaluetextArea}
            onBlur={onBlur}
          />
        ) : (
          <input
            // max={maxLength}

            type={type}
            placeholder={placeholder}
            className="w-full border-b-2 focus:outline-none grow textField"
            onChange={onChange}
            value={inputvalue}
            onClick={onClick}
            onFocus={onFocus}
            maxLength={maxLength}
            disabled={disabled}
            onBlur={onBlur}
          />
        )}
      </div>
    </div>
  );
};

export const PermissionInput = ({
  permissionName,
  diasableId,
  readId,
  enableId,
  name,
  permission,
  onClick,
  isRestrict,
  branchLevelId,
  childCompanyId,
  isReadOnly,
}) => {
  return (
    <>
      <div className="flex space-y-0 items-center px-2 my-1.5">
        <div className="w-40 text-sm font-semibold text-primary">
          {permissionName}
        </div>
        <div className="flex items-start space-x-2 pl-7 ">
          <div className="flex items-center ">
            <input
              checked={permission === "DISABLE"}
              id={diasableId}
              type="radio"
              value=""
              onClick={onClick}
              name={name}
              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-full  dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600 outline-none"
            />
            <label
              for={diasableId}
              className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
            >
              Disable
            </label>
          </div>
          {isReadOnly && (
            <div className="flex items-center">
              <input
                checked={permission === "READ_ONLY"}
                id={readId}
                type="radio"
                value=""
                name={name}
                onClick={onClick}
                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600 outline-none"
              />
              <label
                for={readId}
                className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >
                Read Only
              </label>
            </div>
          )}
          <div className="flex items-center">
            <input
              checked={permission === "ENABLE"}
              id={enableId}
              type="radio"
              value=""
              onClick={onClick}
              name={name}
              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600 outline-none"
            />
            <label
              for={enableId}
              className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
            >
              Enable
            </label>
          </div>
          {isRestrict && (
            <div className="flex items-center">
              <input
                checked={permission === "BRANCH_LEVEL"}
                id={branchLevelId}
                type="radio"
                value=""
                onClick={onClick}
                name={name}
                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600 outline-none"
              />
              <label
                for={branchLevelId}
                className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >
                Branch Level
              </label>
            </div>
          )}
          {isRestrict && (
            <div className="flex items-center">
              <input
                checked={permission === "CHILD_COMPANY"}
                id={childCompanyId}
                type="radio"
                value=""
                onClick={onClick}
                name={name}
                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600 outline-none"
              />
              <label
                for={childCompanyId}
                className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >
                Child Company
              </label>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
